module.exports = /******/
function(modules) {
    /******/
    /******/
    // The require function
    /******/
    function __webpack_require__(moduleId) {
        /******/
        /******/
        // Check if module is in cache
        /******/
        if (installedModules[moduleId]) /******/
        return installedModules[moduleId].exports;
        /******/
        /******/
        // Create a new module (and put it into the cache)
        /******/
        var module = installedModules[moduleId] = {
            /******/
            exports: {},
            /******/
            id: moduleId,
            /******/
            loaded: !1
        };
        /******/
        /******/
        // Return the exports of the module
        /******/
        /******/
        /******/
        // Execute the module function
        /******/
        /******/
        /******/
        // Flag the module as loaded
        /******/
        return modules[moduleId].call(module.exports, module, module.exports, __webpack_require__), 
        module.loaded = !0, module.exports;
    }
    // webpackBootstrap
    /******/
    // The module cache
    /******/
    var installedModules = {};
    /******/
    /******/
    // Load entry module and return exports
    /******/
    /******/
    /******/
    /******/
    // expose the modules object (__webpack_modules__)
    /******/
    /******/
    /******/
    // expose the module cache
    /******/
    /******/
    /******/
    // __webpack_public_path__
    /******/
    return __webpack_require__.m = modules, __webpack_require__.c = installedModules, 
    __webpack_require__.p = "", __webpack_require__(0);
}([ /* 0 */
/***/
function(module, exports, __webpack_require__) {
    module.exports = __webpack_require__(9);
}, /* 1 */
, /* 2 */
, /* 3 */
, /* 4 */
, /* 5 */
, /* 6 */
, /* 7 */
, /* 8 */
, /* 9 */
/***/
function(module, exports, __webpack_require__) {
    "use strict";
    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    Object.defineProperty(exports, "__esModule", {
        value: !0
    });
    var _Navigation = __webpack_require__(10);
    Object.defineProperty(exports, "default", {
        enumerable: !0,
        get: function() {
            return _interopRequireDefault(_Navigation).default;
        }
    });
    var _ContainerItem = __webpack_require__(51);
    Object.defineProperty(exports, "AkContainerItem", {
        enumerable: !0,
        get: function() {
            return _interopRequireDefault(_ContainerItem).default;
        }
    });
    var _ContainerItemGroup = __webpack_require__(58);
    Object.defineProperty(exports, "AkContainerItemGroup", {
        enumerable: !0,
        get: function() {
            return _interopRequireDefault(_ContainerItemGroup).default;
        }
    });
    var _ContainerLogo = __webpack_require__(61);
    Object.defineProperty(exports, "AkContainerLogo", {
        enumerable: !0,
        get: function() {
            return _interopRequireDefault(_ContainerLogo).default;
        }
    });
    var _ContainerTitle = __webpack_require__(64);
    Object.defineProperty(exports, "AkContainerTitle", {
        enumerable: !0,
        get: function() {
            return _interopRequireDefault(_ContainerTitle).default;
        }
    });
    var _ContainerNavigation = __webpack_require__(40);
    Object.defineProperty(exports, "AkContainerNavigation", {
        enumerable: !0,
        get: function() {
            return _interopRequireDefault(_ContainerNavigation).default;
        }
    });
    var _ContainerNavigationNested = __webpack_require__(67);
    Object.defineProperty(exports, "AkContainerNavigationNested", {
        enumerable: !0,
        get: function() {
            return _interopRequireDefault(_ContainerNavigationNested).default;
        }
    });
    var _CreateDrawer = __webpack_require__(70);
    Object.defineProperty(exports, "AkCreateDrawer", {
        enumerable: !0,
        get: function() {
            return _interopRequireDefault(_CreateDrawer).default;
        }
    });
    var _CustomDrawer = __webpack_require__(78);
    Object.defineProperty(exports, "AkCustomDrawer", {
        enumerable: !0,
        get: function() {
            return _interopRequireDefault(_CustomDrawer).default;
        }
    });
    var _SearchDrawer = __webpack_require__(79);
    Object.defineProperty(exports, "AkSearchDrawer", {
        enumerable: !0,
        get: function() {
            return _interopRequireDefault(_SearchDrawer).default;
        }
    });
    var _DrawerItem = __webpack_require__(80);
    Object.defineProperty(exports, "AkDrawerItem", {
        enumerable: !0,
        get: function() {
            return _interopRequireDefault(_DrawerItem).default;
        }
    });
    var _GlobalNavigation = __webpack_require__(21);
    Object.defineProperty(exports, "AkGlobalNavigation", {
        enumerable: !0,
        get: function() {
            return _interopRequireDefault(_GlobalNavigation).default;
        }
    });
    var _GlobalItem = __webpack_require__(33);
    Object.defineProperty(exports, "AkGlobalItem", {
        enumerable: !0,
        get: function() {
            return _interopRequireDefault(_GlobalItem).default;
        }
    });
}, /* 10 */
/***/
function(module, exports, __webpack_require__) {
    "use strict";
    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    Object.defineProperty(exports, "__esModule", {
        value: !0
    });
    var _getPrototypeOf = __webpack_require__(11), _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf), _classCallCheck2 = __webpack_require__(12), _classCallCheck3 = _interopRequireDefault(_classCallCheck2), _createClass2 = __webpack_require__(13), _createClass3 = _interopRequireDefault(_createClass2), _possibleConstructorReturn2 = __webpack_require__(14), _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2), _inherits2 = __webpack_require__(15), _inherits3 = _interopRequireDefault(_inherits2), _react = __webpack_require__(16), _react2 = _interopRequireDefault(_react), _Navigation = __webpack_require__(17), _Navigation2 = _interopRequireDefault(_Navigation), _GlobalNavigation = __webpack_require__(21), _GlobalNavigation2 = _interopRequireDefault(_GlobalNavigation), _ContainerNavigation = __webpack_require__(40), _ContainerNavigation2 = _interopRequireDefault(_ContainerNavigation), _DefaultLinkComponent = __webpack_require__(36), _DefaultLinkComponent2 = _interopRequireDefault(_DefaultLinkComponent), _Resizer = __webpack_require__(47), _Resizer2 = _interopRequireDefault(_Resizer), _Spacer = __webpack_require__(27), _Spacer2 = _interopRequireDefault(_Spacer), _sharedVariables = __webpack_require__(26), _collapse = __webpack_require__(50), _collapse2 = _interopRequireDefault(_collapse), Navigation = function(_PureComponent) {
        function Navigation(props) {
            (0, _classCallCheck3.default)(this, Navigation);
            var _this = (0, _possibleConstructorReturn3.default)(this, (Navigation.__proto__ || (0, 
            _getPrototypeOf2.default)(Navigation)).call(this, props));
            return _this.onResize = function(resizeDelta) {
                _this.setState({
                    resizeDelta: resizeDelta
                });
            }, _this.getRenderedWidth = function() {
                var baselineWidth = _this.props.isOpen ? _this.props.width : _sharedVariables.containerClosedWidth, minWidth = _this.props.isCollapsible ? _sharedVariables.containerClosedWidth : _sharedVariables.navigationOpenWidth;
                return Math.max(minWidth, baselineWidth + _this.state.resizeDelta);
            }, _this.triggerResizeHandler = function() {
                var width = _this.getRenderedWidth(), snappedWidth = function() {
                    return width > _sharedVariables.navigationOpenWidth ? width : width < _sharedVariables.resizeClosedBreakpoint ? _sharedVariables.containerClosedWidth : _sharedVariables.navigationOpenWidth;
                }(), resizeState = {
                    isOpen: width >= _sharedVariables.resizeClosedBreakpoint,
                    width: snappedWidth
                };
                _this.setState({
                    resizeDelta: 0
                }, function() {
                    this.props.onResize(resizeState);
                });
            }, _this.state = {
                resizeDelta: 0
            }, _this;
        }
        return (0, _inherits3.default)(Navigation, _PureComponent), (0, _createClass3.default)(Navigation, [ {
            key: "render",
            value: function() {
                var _props = this.props, children = _props.children, containerAppearance = _props.containerAppearance, containerHeaderComponent = _props.containerHeaderComponent, drawers = _props.drawers, globalAccountItem = _props.globalAccountItem, globalCreateIcon = _props.globalCreateIcon, globalHelpItem = _props.globalHelpItem, globalPrimaryIcon = _props.globalPrimaryIcon, globalPrimaryItemHref = _props.globalPrimaryItemHref, globalSearchIcon = _props.globalSearchIcon, isOpen = _props.isOpen, isResizeable = _props.isResizeable, linkComponent = _props.linkComponent, onCreateDrawerOpen = _props.onCreateDrawerOpen, onResizeStart = _props.onResizeStart, onSearchDrawerOpen = _props.onSearchDrawerOpen, shouldAnimate = 0 === this.state.resizeDelta, renderedWidth = this.getRenderedWidth(), isPartiallyCollapsed = renderedWidth < _sharedVariables.globalOpenWidth + _sharedVariables.containerClosedWidth;
                return _react2.default.createElement("div", {
                    className: _Navigation2.default.navigation
                }, _react2.default.createElement(_Spacer2.default, {
                    shouldAnimate: shouldAnimate,
                    width: renderedWidth
                }), _react2.default.createElement("div", {
                    className: _Navigation2.default.navigationInner
                }, _react2.default.createElement("div", {
                    style: {
                        zIndex: !isPartiallyCollapsed && 1
                    }
                }, _react2.default.createElement(_GlobalNavigation2.default, {
                    accountItem: globalAccountItem,
                    createIcon: globalCreateIcon,
                    helpItem: globalHelpItem,
                    linkComponent: linkComponent,
                    onCreateActivate: onCreateDrawerOpen,
                    onSearchActivate: onSearchDrawerOpen,
                    primaryIcon: globalPrimaryIcon,
                    primaryItemHref: globalPrimaryItemHref,
                    searchIcon: globalSearchIcon,
                    shouldAnimate: shouldAnimate
                })), _react2.default.createElement("div", {
                    style: {
                        zIndex: 2
                    }
                }, drawers), _react2.default.createElement("div", null, _react2.default.createElement(_ContainerNavigation2.default, {
                    appearance: containerAppearance,
                    areGlobalActionsVisible: !isOpen && this.state.resizeDelta <= 0,
                    globalCreateIcon: globalCreateIcon,
                    globalPrimaryIcon: globalPrimaryIcon,
                    globalPrimaryItemHref: globalPrimaryItemHref,
                    globalSearchIcon: globalSearchIcon,
                    headerComponent: containerHeaderComponent,
                    linkComponent: linkComponent,
                    offsetX: Math.min(renderedWidth - (_sharedVariables.globalOpenWidth + _sharedVariables.containerClosedWidth), 0),
                    onGlobalCreateActivate: onCreateDrawerOpen,
                    onGlobalSearchActivate: onSearchDrawerOpen,
                    shouldAnimate: shouldAnimate,
                    width: (0, _collapse2.default)(renderedWidth)
                }, children)), isResizeable ? _react2.default.createElement(_Resizer2.default, {
                    onResize: this.onResize,
                    onResizeStart: onResizeStart,
                    onResizeEnd: this.triggerResizeHandler
                }) : null));
            }
        } ]), Navigation;
    }(_react.PureComponent);
    Navigation.propTypes = {
        children: _react.PropTypes.node,
        containerAppearance: _react.PropTypes.string,
        containerHeaderComponent: _react.PropTypes.func,
        drawers: _react.PropTypes.arrayOf(_react.PropTypes.node),
        globalAccountItem: _react.PropTypes.node,
        globalCreateIcon: _react.PropTypes.node,
        globalHelpItem: _react.PropTypes.node,
        globalPrimaryIcon: _react.PropTypes.node,
        globalPrimaryItemHref: _react.PropTypes.string,
        globalSearchIcon: _react.PropTypes.node,
        isCollapsible: _react.PropTypes.bool,
        isOpen: _react.PropTypes.bool,
        isResizeable: _react.PropTypes.bool,
        linkComponent: _react.PropTypes.func,
        onCreateDrawerOpen: _react.PropTypes.func,
        onResize: _react.PropTypes.func,
        onResizeStart: _react.PropTypes.func,
        onSearchDrawerOpen: _react.PropTypes.func,
        width: _react.PropTypes.number
    }, Navigation.defaultProps = {
        containerAppearance: "default",
        drawers: [],
        globalAccountDropdownComponent: function(_ref) {
            var children = _ref.children;
            return children;
        },
        globalHelpDropdownComponent: function(_ref2) {
            var children = _ref2.children;
            return children;
        },
        isCollapsible: !0,
        isCreateDrawerOpen: !1,
        isOpen: !0,
        isResizeable: !0,
        isSearchDrawerOpen: !1,
        linkComponent: _DefaultLinkComponent2.default,
        onCreateDrawerOpen: function() {},
        onResize: function() {},
        onResizeStart: function() {},
        onSearchDrawerOpen: function() {},
        width: _sharedVariables.navigationOpenWidth
    }, exports.default = Navigation;
}, /* 11 */
/***/
function(module, exports) {
    module.exports = require("babel-runtime/core-js/object/get-prototype-of");
}, /* 12 */
/***/
function(module, exports) {
    module.exports = require("babel-runtime/helpers/classCallCheck");
}, /* 13 */
/***/
function(module, exports) {
    module.exports = require("babel-runtime/helpers/createClass");
}, /* 14 */
/***/
function(module, exports) {
    module.exports = require("babel-runtime/helpers/possibleConstructorReturn");
}, /* 15 */
/***/
function(module, exports) {
    module.exports = require("babel-runtime/helpers/inherits");
}, /* 16 */
/***/
function(module, exports) {
    module.exports = require("react");
}, /* 17 */
/***/
function(module, exports, __webpack_require__) {
    // style-loader: Adds some css to the DOM by adding a <style> tag
    // load the styles
    var content = __webpack_require__(18);
    "string" == typeof content && (content = [ [ module.id, content, "" ] ]);
    // add the styles to the DOM
    __webpack_require__(20)(content, {});
    content.locals && (module.exports = content.locals);
}, /* 18 */
/***/
function(module, exports, __webpack_require__) {
    exports = module.exports = __webpack_require__(19)(), // imports
    // module
    exports.push([ module.id, "._9olz6NKQA4PJrMIsRfkL0{display:-webkit-box;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;flex-direction:row;z-index:2;-webkit-box-flex:1;flex:1 0 auto}._3oaG4DgDADJh-x9iXzakjp{height:100%;display:-webkit-box;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;flex-direction:row;position:fixed;left:0;z-index:300}", "" ]), 
    // exports
    exports.locals = {
        navigation: "_9olz6NKQA4PJrMIsRfkL0",
        navigation: "_9olz6NKQA4PJrMIsRfkL0",
        navigationInner: "_3oaG4DgDADJh-x9iXzakjp",
        navigationInner: "_3oaG4DgDADJh-x9iXzakjp"
    };
}, /* 19 */
/***/
function(module, exports) {
    /*
		MIT License http://www.opensource.org/licenses/mit-license.php
		Author Tobias Koppers @sokra
	*/
    // css base code, injected by the css-loader
    module.exports = function() {
        var list = [];
        // return the list of modules as css string
        // import a list of modules into the list
        return list.toString = function() {
            for (var result = [], i = 0; i < this.length; i++) {
                var item = this[i];
                item[2] ? result.push("@media " + item[2] + "{" + item[1] + "}") : result.push(item[1]);
            }
            return result.join("");
        }, list.i = function(modules, mediaQuery) {
            "string" == typeof modules && (modules = [ [ null, modules, "" ] ]);
            for (var alreadyImportedModules = {}, i = 0; i < this.length; i++) {
                var id = this[i][0];
                "number" == typeof id && (alreadyImportedModules[id] = !0);
            }
            for (i = 0; i < modules.length; i++) {
                var item = modules[i];
                // skip already imported module
                // this implementation is not 100% perfect for weird media query combinations
                //  when a module is imported multiple times with different media queries.
                //  I hope this will never occur (Hey this way we have smaller bundles)
                "number" == typeof item[0] && alreadyImportedModules[item[0]] || (mediaQuery && !item[2] ? item[2] = mediaQuery : mediaQuery && (item[2] = "(" + item[2] + ") and (" + mediaQuery + ")"), 
                list.push(item));
            }
        }, list;
    };
}, /* 20 */
/***/
function(module, exports, __webpack_require__) {
    function addStylesToDom(styles, options) {
        for (var i = 0; i < styles.length; i++) {
            var item = styles[i], domStyle = stylesInDom[item.id];
            if (domStyle) {
                domStyle.refs++;
                for (var j = 0; j < domStyle.parts.length; j++) domStyle.parts[j](item.parts[j]);
                for (;j < item.parts.length; j++) domStyle.parts.push(addStyle(item.parts[j], options));
            } else {
                for (var parts = [], j = 0; j < item.parts.length; j++) parts.push(addStyle(item.parts[j], options));
                stylesInDom[item.id] = {
                    id: item.id,
                    refs: 1,
                    parts: parts
                };
            }
        }
    }
    function listToStyles(list) {
        for (var styles = [], newStyles = {}, i = 0; i < list.length; i++) {
            var item = list[i], id = item[0], css = item[1], media = item[2], sourceMap = item[3], part = {
                css: css,
                media: media,
                sourceMap: sourceMap
            };
            newStyles[id] ? newStyles[id].parts.push(part) : styles.push(newStyles[id] = {
                id: id,
                parts: [ part ]
            });
        }
        return styles;
    }
    function insertStyleElement(options, styleElement) {
        var head = getHeadElement(), lastStyleElementInsertedAtTop = styleElementsInsertedAtTop[styleElementsInsertedAtTop.length - 1];
        if ("top" === options.insertAt) lastStyleElementInsertedAtTop ? lastStyleElementInsertedAtTop.nextSibling ? head.insertBefore(styleElement, lastStyleElementInsertedAtTop.nextSibling) : head.appendChild(styleElement) : head.insertBefore(styleElement, head.firstChild), 
        styleElementsInsertedAtTop.push(styleElement); else {
            if ("bottom" !== options.insertAt) throw new Error("Invalid value for parameter 'insertAt'. Must be 'top' or 'bottom'.");
            head.appendChild(styleElement);
        }
    }
    function removeStyleElement(styleElement) {
        styleElement.parentNode.removeChild(styleElement);
        var idx = styleElementsInsertedAtTop.indexOf(styleElement);
        idx >= 0 && styleElementsInsertedAtTop.splice(idx, 1);
    }
    function createStyleElement(options) {
        var styleElement = document.createElement("style");
        return styleElement.type = "text/css", insertStyleElement(options, styleElement), 
        styleElement;
    }
    function createLinkElement(options) {
        var linkElement = document.createElement("link");
        return linkElement.rel = "stylesheet", insertStyleElement(options, linkElement), 
        linkElement;
    }
    function addStyle(obj, options) {
        var styleElement, update, remove;
        if (options.singleton) {
            var styleIndex = singletonCounter++;
            styleElement = singletonElement || (singletonElement = createStyleElement(options)), 
            update = applyToSingletonTag.bind(null, styleElement, styleIndex, !1), remove = applyToSingletonTag.bind(null, styleElement, styleIndex, !0);
        } else obj.sourceMap && "function" == typeof URL && "function" == typeof URL.createObjectURL && "function" == typeof URL.revokeObjectURL && "function" == typeof Blob && "function" == typeof btoa ? (styleElement = createLinkElement(options), 
        update = updateLink.bind(null, styleElement), remove = function() {
            removeStyleElement(styleElement), styleElement.href && URL.revokeObjectURL(styleElement.href);
        }) : (styleElement = createStyleElement(options), update = applyToTag.bind(null, styleElement), 
        remove = function() {
            removeStyleElement(styleElement);
        });
        return update(obj), function(newObj) {
            if (newObj) {
                if (newObj.css === obj.css && newObj.media === obj.media && newObj.sourceMap === obj.sourceMap) return;
                update(obj = newObj);
            } else remove();
        };
    }
    function applyToSingletonTag(styleElement, index, remove, obj) {
        var css = remove ? "" : obj.css;
        if (styleElement.styleSheet) styleElement.styleSheet.cssText = replaceText(index, css); else {
            var cssNode = document.createTextNode(css), childNodes = styleElement.childNodes;
            childNodes[index] && styleElement.removeChild(childNodes[index]), childNodes.length ? styleElement.insertBefore(cssNode, childNodes[index]) : styleElement.appendChild(cssNode);
        }
    }
    function applyToTag(styleElement, obj) {
        var css = obj.css, media = obj.media;
        if (media && styleElement.setAttribute("media", media), styleElement.styleSheet) styleElement.styleSheet.cssText = css; else {
            for (;styleElement.firstChild; ) styleElement.removeChild(styleElement.firstChild);
            styleElement.appendChild(document.createTextNode(css));
        }
    }
    function updateLink(linkElement, obj) {
        var css = obj.css, sourceMap = obj.sourceMap;
        sourceMap && (// http://stackoverflow.com/a/26603875
        css += "\n/*# sourceMappingURL=data:application/json;base64," + btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))) + " */");
        var blob = new Blob([ css ], {
            type: "text/css"
        }), oldSrc = linkElement.href;
        linkElement.href = URL.createObjectURL(blob), oldSrc && URL.revokeObjectURL(oldSrc);
    }
    /*
		MIT License http://www.opensource.org/licenses/mit-license.php
		Author Tobias Koppers @sokra
	*/
    var stylesInDom = {}, memoize = function(fn) {
        var memo;
        return function() {
            return "undefined" == typeof memo && (memo = fn.apply(this, arguments)), memo;
        };
    }, isOldIE = memoize(function() {
        return /msie [6-9]\b/.test(window.navigator.userAgent.toLowerCase());
    }), getHeadElement = memoize(function() {
        return document.head || document.getElementsByTagName("head")[0];
    }), singletonElement = null, singletonCounter = 0, styleElementsInsertedAtTop = [];
    module.exports = function(list, options) {
        options = options || {}, // Force single-tag solution on IE6-9, which has a hard limit on the # of <style>
        // tags it will allow on a page
        "undefined" == typeof options.singleton && (options.singleton = isOldIE()), // By default, add <style> tags to the bottom of <head>.
        "undefined" == typeof options.insertAt && (options.insertAt = "bottom");
        var styles = listToStyles(list);
        return addStylesToDom(styles, options), function(newList) {
            for (var mayRemove = [], i = 0; i < styles.length; i++) {
                var item = styles[i], domStyle = stylesInDom[item.id];
                domStyle.refs--, mayRemove.push(domStyle);
            }
            if (newList) {
                var newStyles = listToStyles(newList);
                addStylesToDom(newStyles, options);
            }
            for (var i = 0; i < mayRemove.length; i++) {
                var domStyle = mayRemove[i];
                if (0 === domStyle.refs) {
                    for (var j = 0; j < domStyle.parts.length; j++) domStyle.parts[j]();
                    delete stylesInDom[domStyle.id];
                }
            }
        };
    };
    var replaceText = function() {
        var textStore = [];
        return function(index, replacement) {
            return textStore[index] = replacement, textStore.filter(Boolean).join("\n");
        };
    }();
}, /* 21 */
/***/
function(module, exports, __webpack_require__) {
    "use strict";
    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    Object.defineProperty(exports, "__esModule", {
        value: !0
    });
    var _defineProperty2 = __webpack_require__(22), _defineProperty3 = _interopRequireDefault(_defineProperty2), _getPrototypeOf = __webpack_require__(11), _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf), _classCallCheck2 = __webpack_require__(12), _classCallCheck3 = _interopRequireDefault(_classCallCheck2), _createClass2 = __webpack_require__(13), _createClass3 = _interopRequireDefault(_createClass2), _possibleConstructorReturn2 = __webpack_require__(14), _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2), _inherits2 = __webpack_require__(15), _inherits3 = _interopRequireDefault(_inherits2), _react = __webpack_require__(16), _react2 = _interopRequireDefault(_react), _classnames = __webpack_require__(23), _classnames2 = _interopRequireDefault(_classnames), _GlobalNavigation = __webpack_require__(24), _GlobalNavigation2 = _interopRequireDefault(_GlobalNavigation), _sharedVariables = __webpack_require__(26), _Spacer = __webpack_require__(27), _Spacer2 = _interopRequireDefault(_Spacer), _GlobalActions = __webpack_require__(30), _GlobalActions2 = _interopRequireDefault(_GlobalActions), _DefaultLinkComponent = __webpack_require__(36), _DefaultLinkComponent2 = _interopRequireDefault(_DefaultLinkComponent), GlobalNavigation = function(_PureComponent) {
        function GlobalNavigation() {
            return (0, _classCallCheck3.default)(this, GlobalNavigation), (0, _possibleConstructorReturn3.default)(this, (GlobalNavigation.__proto__ || (0, 
            _getPrototypeOf2.default)(GlobalNavigation)).apply(this, arguments));
        }
        return (0, _inherits3.default)(GlobalNavigation, _PureComponent), (0, _createClass3.default)(GlobalNavigation, [ {
            key: "render",
            value: function() {
                var _props = this.props, accountItem = _props.accountItem, createIcon = _props.createIcon, helpItem = _props.helpItem, linkComponent = _props.linkComponent, onCreateActivate = _props.onCreateActivate, onSearchActivate = _props.onSearchActivate, primaryIcon = _props.primaryIcon, primaryItemHref = _props.primaryItemHref, searchIcon = _props.searchIcon, shouldAnimate = _props.shouldAnimate;
                return _react2.default.createElement("div", {
                    className: (0, _classnames2.default)(_GlobalNavigation2.default.globalNavigationOuter, (0, 
                    _defineProperty3.default)({}, _GlobalNavigation2.default.shouldAnimate, shouldAnimate))
                }, _react2.default.createElement(_Spacer2.default, {
                    shouldAnimate: shouldAnimate,
                    width: _sharedVariables.globalOpenWidth
                }), _react2.default.createElement("div", {
                    className: _GlobalNavigation2.default.globalNavigation
                }, _react2.default.createElement("div", {
                    className: _GlobalNavigation2.default.primaryContainer
                }, _react2.default.createElement(_GlobalActions2.default, {
                    createIcon: createIcon,
                    linkComponent: linkComponent,
                    onCreateActivate: onCreateActivate,
                    onSearchActivate: onSearchActivate,
                    primaryIcon: primaryIcon,
                    primaryItemHref: primaryItemHref,
                    searchIcon: searchIcon
                })), _react2.default.createElement("div", {
                    className: _GlobalNavigation2.default.secondaryContainer
                }, helpItem, accountItem)));
            }
        } ]), GlobalNavigation;
    }(_react.PureComponent);
    GlobalNavigation.propTypes = {
        accountItem: _react.PropTypes.node,
        helpItem: _react.PropTypes.node,
        linkComponent: _react.PropTypes.func,
        primaryIcon: _react.PropTypes.node,
        primaryItemHref: _react.PropTypes.string,
        shouldAnimate: _react.PropTypes.bool,
        searchIcon: _react.PropTypes.node,
        onSearchActivate: _react.PropTypes.func,
        onCreateActivate: _react.PropTypes.func,
        createIcon: _react.PropTypes.node
    }, GlobalNavigation.defaultProps = {
        accountItem: null,
        helpItem: null,
        linkComponent: _DefaultLinkComponent2.default,
        primaryIcon: null,
        shouldAnimate: !1
    }, exports.default = GlobalNavigation;
}, /* 22 */
/***/
function(module, exports) {
    module.exports = require("babel-runtime/helpers/defineProperty");
}, /* 23 */
/***/
function(module, exports) {
    module.exports = require("classnames");
}, /* 24 */
/***/
function(module, exports, __webpack_require__) {
    // style-loader: Adds some css to the DOM by adding a <style> tag
    // load the styles
    var content = __webpack_require__(25);
    "string" == typeof content && (content = [ [ module.id, content, "" ] ]);
    // add the styles to the DOM
    __webpack_require__(20)(content, {});
    content.locals && (module.exports = content.locals);
}, /* 25 */
/***/
function(module, exports, __webpack_require__) {
    exports = module.exports = __webpack_require__(19)(), // imports
    // module
    exports.push([ module.id, ".vMpZ-UnY_xcMDHCYq6TDV{position:relative}._2z7mHzpMBsZE559Q8_CPi-{-webkit-box-align:center;align-items:center;background:#0049b0;box-sizing:border-box;display:-webkit-box;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;flex-direction:column;height:100%;padding-bottom:0;padding:16px 0;position:fixed;width:64px}._3fNHNyyKYyBhRzApxP-jFh ._2z7mHzpMBsZE559Q8_CPi-{-webkit-transition:-webkit-transform .2s;transition:-webkit-transform .2s;transition:transform .2s;transition:transform .2s,-webkit-transform .2s}.qHhE-TMq_yGEs63m_rWUd{margin-bottom:12px;margin-top:4px}._3F5JyeRltq49wKKXWB2BEY{-webkit-box-flex:1;flex:1}.p2bUmaNt5WBkAg6cBoKvZ{display:-webkit-box;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;flex-direction:column;-webkit-box-align:center;align-items:center;padding-bottom:20px}", "" ]), 
    // exports
    exports.locals = {
        globalNavigationOuter: "vMpZ-UnY_xcMDHCYq6TDV",
        globalNavigationOuter: "vMpZ-UnY_xcMDHCYq6TDV",
        globalNavigation: "_2z7mHzpMBsZE559Q8_CPi-",
        globalNavigation: "_2z7mHzpMBsZE559Q8_CPi-",
        shouldAnimate: "_3fNHNyyKYyBhRzApxP-jFh",
        shouldAnimate: "_3fNHNyyKYyBhRzApxP-jFh",
        primaryItem: "qHhE-TMq_yGEs63m_rWUd",
        primaryItem: "qHhE-TMq_yGEs63m_rWUd",
        primaryContainer: "_3F5JyeRltq49wKKXWB2BEY",
        primaryContainer: "_3F5JyeRltq49wKKXWB2BEY",
        secondaryContainer: "p2bUmaNt5WBkAg6cBoKvZ",
        secondaryContainer: "p2bUmaNt5WBkAg6cBoKvZ"
    };
}, /* 26 */
/***/
function(module, exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: !0
    });
    // NOTE: this is duplicated in shared-variables.less
    var globalOpenWidth = exports.globalOpenWidth = 64, containerOpenWidth = exports.containerOpenWidth = 220, containerClosedWidth = exports.containerClosedWidth = 64;
    exports.navigationOpenWidth = globalOpenWidth + containerOpenWidth, exports.resizeClosedBreakpoint = globalOpenWidth + containerOpenWidth / 2, 
    exports.collapseBreakpoint = globalOpenWidth + containerClosedWidth, exports.containerNavigationNestedPageSpacing = 8, 
    exports.searchIconOffset = 68, exports.createIconOffset = 108;
}, /* 27 */
/***/
function(module, exports, __webpack_require__) {
    "use strict";
    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    Object.defineProperty(exports, "__esModule", {
        value: !0
    });
    var _defineProperty2 = __webpack_require__(22), _defineProperty3 = _interopRequireDefault(_defineProperty2), _getPrototypeOf = __webpack_require__(11), _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf), _classCallCheck2 = __webpack_require__(12), _classCallCheck3 = _interopRequireDefault(_classCallCheck2), _createClass2 = __webpack_require__(13), _createClass3 = _interopRequireDefault(_createClass2), _possibleConstructorReturn2 = __webpack_require__(14), _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2), _inherits2 = __webpack_require__(15), _inherits3 = _interopRequireDefault(_inherits2), _react = __webpack_require__(16), _react2 = _interopRequireDefault(_react), _classnames = __webpack_require__(23), _classnames2 = _interopRequireDefault(_classnames), _Spacer = __webpack_require__(28), _Spacer2 = _interopRequireDefault(_Spacer), Spacer = function(_PureComponent) {
        function Spacer() {
            return (0, _classCallCheck3.default)(this, Spacer), (0, _possibleConstructorReturn3.default)(this, (Spacer.__proto__ || (0, 
            _getPrototypeOf2.default)(Spacer)).apply(this, arguments));
        }
        return (0, _inherits3.default)(Spacer, _PureComponent), (0, _createClass3.default)(Spacer, [ {
            key: "render",
            value: function() {
                return _react2.default.createElement("div", {
                    className: (0, _classnames2.default)(_Spacer2.default.spacer, (0, _defineProperty3.default)({}, _Spacer2.default.shouldAnimate, this.props.shouldAnimate)),
                    style: {
                        width: this.props.width
                    }
                });
            }
        } ]), Spacer;
    }(_react.PureComponent);
    Spacer.propTypes = {
        width: _react.PropTypes.number,
        shouldAnimate: _react.PropTypes.bool
    }, Spacer.defaultProps = {
        width: 0,
        shouldAnimate: !1
    }, exports.default = Spacer;
}, /* 28 */
/***/
function(module, exports, __webpack_require__) {
    // style-loader: Adds some css to the DOM by adding a <style> tag
    // load the styles
    var content = __webpack_require__(29);
    "string" == typeof content && (content = [ [ module.id, content, "" ] ]);
    // add the styles to the DOM
    __webpack_require__(20)(content, {});
    content.locals && (module.exports = content.locals);
}, /* 29 */
/***/
function(module, exports, __webpack_require__) {
    exports = module.exports = __webpack_require__(19)(), // imports
    // module
    exports.push([ module.id, "._3Wv3Xo6vHFF59vNCx6V19L._3Jf_JOF4hFiCUoyGHI9FA4{-webkit-transition:width .2s;transition:width .2s}", "" ]), 
    // exports
    exports.locals = {
        spacer: "_3Wv3Xo6vHFF59vNCx6V19L",
        spacer: "_3Wv3Xo6vHFF59vNCx6V19L",
        shouldAnimate: "_3Jf_JOF4hFiCUoyGHI9FA4",
        shouldAnimate: "_3Jf_JOF4hFiCUoyGHI9FA4"
    };
}, /* 30 */
/***/
function(module, exports, __webpack_require__) {
    "use strict";
    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    Object.defineProperty(exports, "__esModule", {
        value: !0
    });
    var _defineProperty2 = __webpack_require__(22), _defineProperty3 = _interopRequireDefault(_defineProperty2), _getPrototypeOf = __webpack_require__(11), _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf), _classCallCheck2 = __webpack_require__(12), _classCallCheck3 = _interopRequireDefault(_classCallCheck2), _createClass2 = __webpack_require__(13), _createClass3 = _interopRequireDefault(_createClass2), _possibleConstructorReturn2 = __webpack_require__(14), _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2), _inherits2 = __webpack_require__(15), _inherits3 = _interopRequireDefault(_inherits2), _react = __webpack_require__(16), _react2 = _interopRequireDefault(_react), _classnames = __webpack_require__(23), _classnames2 = _interopRequireDefault(_classnames), _GlobalActions = __webpack_require__(31), _GlobalActions2 = _interopRequireDefault(_GlobalActions), _GlobalItem = __webpack_require__(33), _GlobalItem2 = _interopRequireDefault(_GlobalItem), _DrawerTrigger = __webpack_require__(37), _DrawerTrigger2 = _interopRequireDefault(_DrawerTrigger), _DefaultLinkComponent = __webpack_require__(36), _DefaultLinkComponent2 = _interopRequireDefault(_DefaultLinkComponent), GlobalActions = function(_PureComponent) {
        function GlobalActions() {
            return (0, _classCallCheck3.default)(this, GlobalActions), (0, _possibleConstructorReturn3.default)(this, (GlobalActions.__proto__ || (0, 
            _getPrototypeOf2.default)(GlobalActions)).apply(this, arguments));
        }
        return (0, _inherits3.default)(GlobalActions, _PureComponent), (0, _createClass3.default)(GlobalActions, [ {
            key: "render",
            value: function() {
                var _props = this.props, appearance = _props.appearance, createIcon = _props.createIcon, isVisible = _props.isVisible, linkComponent = _props.linkComponent, onCreateActivate = _props.onCreateActivate, onSearchActivate = _props.onSearchActivate, primaryIcon = _props.primaryIcon, primaryItemHref = _props.primaryItemHref, searchIcon = _props.searchIcon;
                return _react2.default.createElement("div", {
                    className: (0, _classnames2.default)(_GlobalActions2.default.globalActions, (0, 
                    _defineProperty3.default)({}, _GlobalActions2.default.isVisible, isVisible))
                }, primaryIcon ? _react2.default.createElement("div", {
                    className: _GlobalActions2.default.primaryItem
                }, _react2.default.createElement(_GlobalItem2.default, {
                    appearance: appearance,
                    href: primaryItemHref,
                    linkComponent: linkComponent,
                    size: "medium"
                }, primaryIcon)) : null, _react2.default.createElement("div", {
                    className: _GlobalActions2.default.actions
                }, searchIcon ? _react2.default.createElement(_DrawerTrigger2.default, {
                    onActivate: onSearchActivate
                }, _react2.default.createElement(_GlobalItem2.default, {
                    appearance: appearance,
                    size: "medium"
                }, searchIcon)) : null, createIcon ? _react2.default.createElement(_DrawerTrigger2.default, {
                    onActivate: onCreateActivate
                }, _react2.default.createElement(_GlobalItem2.default, {
                    appearance: appearance,
                    size: "medium"
                }, createIcon)) : null));
            }
        } ]), GlobalActions;
    }(_react.PureComponent);
    GlobalActions.propTypes = {
        appearance: _react.PropTypes.string,
        createIcon: _react.PropTypes.node,
        isVisible: _react.PropTypes.bool,
        linkComponent: _react.PropTypes.func,
        onCreateActivate: _react.PropTypes.func,
        onSearchActivate: _react.PropTypes.func,
        primaryIcon: _react.PropTypes.node,
        primaryItemHref: _react.PropTypes.string,
        searchIcon: _react.PropTypes.node
    }, GlobalActions.defaultProps = {
        isVisible: !0,
        linkComponent: _DefaultLinkComponent2.default
    }, exports.default = GlobalActions;
}, /* 31 */
/***/
function(module, exports, __webpack_require__) {
    // style-loader: Adds some css to the DOM by adding a <style> tag
    // load the styles
    var content = __webpack_require__(32);
    "string" == typeof content && (content = [ [ module.id, content, "" ] ]);
    // add the styles to the DOM
    __webpack_require__(20)(content, {});
    content.locals && (module.exports = content.locals);
}, /* 32 */
/***/
function(module, exports, __webpack_require__) {
    exports = module.exports = __webpack_require__(19)(), // imports
    // module
    exports.push([ module.id, "._1pFjMJHlLYPtAqpUTgNIoO{-webkit-box-align:center;align-items:center;display:-webkit-box;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;flex-direction:column;margin-top:12px}._2qH1NEpvXtMoINVK1OKvWF{box-sizing:border-box;height:0;opacity:0;visibility:hidden;-webkit-transition:height .22s,margin .22s,opacity .22s;transition:height .22s,margin .22s,opacity .22s}._2qH1NEpvXtMoINVK1OKvWF ._2iPxUMZD5Uq_MrNcgRrSq_{-webkit-box-align:center;align-items:center;display:-webkit-box;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;flex-direction:column}._2qH1NEpvXtMoINVK1OKvWF._3QwNi-QsgfVzKqXMUAS_gK{height:132px;margin-bottom:28px;opacity:1;visibility:visible}", "" ]), 
    // exports
    exports.locals = {
        actions: "_1pFjMJHlLYPtAqpUTgNIoO",
        actions: "_1pFjMJHlLYPtAqpUTgNIoO",
        globalActions: "_2qH1NEpvXtMoINVK1OKvWF",
        globalActions: "_2qH1NEpvXtMoINVK1OKvWF",
        primaryItem: "_2iPxUMZD5Uq_MrNcgRrSq_",
        primaryItem: "_2iPxUMZD5Uq_MrNcgRrSq_",
        isVisible: "_3QwNi-QsgfVzKqXMUAS_gK",
        isVisible: "_3QwNi-QsgfVzKqXMUAS_gK"
    };
}, /* 33 */
/***/
function(module, exports, __webpack_require__) {
    "use strict";
    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    Object.defineProperty(exports, "__esModule", {
        value: !0
    });
    var _defineProperty2 = __webpack_require__(22), _defineProperty3 = _interopRequireDefault(_defineProperty2), _getPrototypeOf = __webpack_require__(11), _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf), _classCallCheck2 = __webpack_require__(12), _classCallCheck3 = _interopRequireDefault(_classCallCheck2), _createClass2 = __webpack_require__(13), _createClass3 = _interopRequireDefault(_createClass2), _possibleConstructorReturn2 = __webpack_require__(14), _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2), _inherits2 = __webpack_require__(15), _inherits3 = _interopRequireDefault(_inherits2), _react = __webpack_require__(16), _react2 = _interopRequireDefault(_react), _GlobalItem = __webpack_require__(34), _GlobalItem2 = _interopRequireDefault(_GlobalItem), _classnames = __webpack_require__(23), _classnames2 = _interopRequireDefault(_classnames), _DefaultLinkComponent = __webpack_require__(36), _DefaultLinkComponent2 = _interopRequireDefault(_DefaultLinkComponent), GlobalItem = function(_PureComponent) {
        function GlobalItem() {
            return (0, _classCallCheck3.default)(this, GlobalItem), (0, _possibleConstructorReturn3.default)(this, (GlobalItem.__proto__ || (0, 
            _getPrototypeOf2.default)(GlobalItem)).apply(this, arguments));
        }
        return (0, _inherits3.default)(GlobalItem, _PureComponent), (0, _createClass3.default)(GlobalItem, [ {
            key: "render",
            value: function() {
                var _classNames, _props = this.props, href = _props.href, Link = _props.linkComponent;
                return _react2.default.createElement(Link, {
                    href: href
                }, _react2.default.createElement("div", {
                    className: (0, _classnames2.default)(_GlobalItem2.default.globalItem, (_classNames = {}, 
                    (0, _defineProperty3.default)(_classNames, _GlobalItem2.default.smallGlobalItem, "small" === this.props.size), 
                    (0, _defineProperty3.default)(_classNames, _GlobalItem2.default.mediumGlobalItem, "medium" === this.props.size), 
                    (0, _defineProperty3.default)(_classNames, _GlobalItem2.default.largeGlobalItem, "large" === this.props.size), 
                    (0, _defineProperty3.default)(_classNames, _GlobalItem2.default.isSelected, this.props.isSelected), 
                    (0, _defineProperty3.default)(_classNames, _GlobalItem2.default.hasContainerAppearance, "container" === this.props.appearance), 
                    _classNames))
                }, this.props.children));
            }
        } ]), GlobalItem;
    }(_react.PureComponent);
    GlobalItem.propTypes = {
        appearance: _react.PropTypes.oneOf([ "container", "global" ]),
        children: _react.PropTypes.node,
        href: _react.PropTypes.string,
        isSelected: _react.PropTypes.bool,
        size: _react.PropTypes.oneOf([ "small", "medium", "large" ]),
        linkComponent: _react.PropTypes.func
    }, GlobalItem.defaultProps = {
        appearance: "global",
        size: "small",
        linkComponent: _DefaultLinkComponent2.default
    }, exports.default = GlobalItem;
}, /* 34 */
/***/
function(module, exports, __webpack_require__) {
    // style-loader: Adds some css to the DOM by adding a <style> tag
    // load the styles
    var content = __webpack_require__(35);
    "string" == typeof content && (content = [ [ module.id, content, "" ] ]);
    // add the styles to the DOM
    __webpack_require__(20)(content, {});
    content.locals && (module.exports = content.locals);
}, /* 35 */
/***/
function(module, exports, __webpack_require__) {
    exports = module.exports = __webpack_require__(19)(), // imports
    // module
    exports.push([ module.id, ".Bd3MfBrblAELTf53W0UcJ{-webkit-box-align:center;align-items:center;border-radius:50%;color:#fff;cursor:pointer;display:-webkit-box;display:flex;-webkit-box-pack:center;justify-content:center}.Bd3MfBrblAELTf53W0UcJ._2Pg74bqZvxpasFPDz7biZN,.Bd3MfBrblAELTf53W0UcJ:focus,.Bd3MfBrblAELTf53W0UcJ:hover{background-color:rgba(9,30,66,.48)}.Bd3MfBrblAELTf53W0UcJ:active{background-color:#2684ff}._29cKeyigLUVY5ReFMoEQlO{height:32px;margin-top:8px;width:32px}._3AERYnX4xKWKyIE1ZN3pkI{height:40px;width:40px}._1gM_ddVyN6hmCQFGwrRJp6{height:48px;width:48px}.MpBgh6SvcS1WlwaxkA8KO{color:#42526e}.MpBgh6SvcS1WlwaxkA8KO:hover{background-color:rgba(9,30,66,.04)}.MpBgh6SvcS1WlwaxkA8KO:active{color:#0049b0;background-color:#deebff}", "" ]), 
    // exports
    exports.locals = {
        globalItem: "Bd3MfBrblAELTf53W0UcJ",
        globalItem: "Bd3MfBrblAELTf53W0UcJ",
        isSelected: "_2Pg74bqZvxpasFPDz7biZN",
        isSelected: "_2Pg74bqZvxpasFPDz7biZN",
        smallGlobalItem: "_29cKeyigLUVY5ReFMoEQlO",
        smallGlobalItem: "_29cKeyigLUVY5ReFMoEQlO",
        mediumGlobalItem: "_3AERYnX4xKWKyIE1ZN3pkI",
        mediumGlobalItem: "_3AERYnX4xKWKyIE1ZN3pkI",
        largeGlobalItem: "_1gM_ddVyN6hmCQFGwrRJp6",
        largeGlobalItem: "_1gM_ddVyN6hmCQFGwrRJp6",
        hasContainerAppearance: "MpBgh6SvcS1WlwaxkA8KO",
        hasContainerAppearance: "MpBgh6SvcS1WlwaxkA8KO"
    };
}, /* 36 */
/***/
function(module, exports, __webpack_require__) {
    "use strict";
    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    Object.defineProperty(exports, "__esModule", {
        value: !0
    });
    var _getPrototypeOf = __webpack_require__(11), _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf), _classCallCheck2 = __webpack_require__(12), _classCallCheck3 = _interopRequireDefault(_classCallCheck2), _createClass2 = __webpack_require__(13), _createClass3 = _interopRequireDefault(_createClass2), _possibleConstructorReturn2 = __webpack_require__(14), _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2), _inherits2 = __webpack_require__(15), _inherits3 = _interopRequireDefault(_inherits2), _react = __webpack_require__(16), _react2 = _interopRequireDefault(_react), DefaultLinkComponent = function(_PureComponent) {
        function DefaultLinkComponent() {
            return (0, _classCallCheck3.default)(this, DefaultLinkComponent), (0, _possibleConstructorReturn3.default)(this, (DefaultLinkComponent.__proto__ || (0, 
            _getPrototypeOf2.default)(DefaultLinkComponent)).apply(this, arguments));
        }
        return (0, _inherits3.default)(DefaultLinkComponent, _PureComponent), (0, _createClass3.default)(DefaultLinkComponent, [ {
            key: "render",
            value: function() {
                var _props = this.props, children = _props.children, className = _props.className, href = _props.href, onClick = _props.onClick, onMouseDown = _props.onMouseDown;
                return href ? _react2.default.createElement("a", {
                    className: className,
                    href: href,
                    onClick: onClick,
                    onMouseDown: onMouseDown
                }, children) : children;
            }
        } ]), DefaultLinkComponent;
    }(_react.PureComponent);
    DefaultLinkComponent.propTypes = {
        children: _react.PropTypes.node,
        className: _react.PropTypes.string,
        href: _react.PropTypes.string,
        onClick: _react.PropTypes.func,
        onMouseDown: _react.PropTypes.func
    }, exports.default = DefaultLinkComponent;
}, /* 37 */
/***/
function(module, exports, __webpack_require__) {
    "use strict";
    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    Object.defineProperty(exports, "__esModule", {
        value: !0
    });
    var _getPrototypeOf = __webpack_require__(11), _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf), _classCallCheck2 = __webpack_require__(12), _classCallCheck3 = _interopRequireDefault(_classCallCheck2), _createClass2 = __webpack_require__(13), _createClass3 = _interopRequireDefault(_createClass2), _possibleConstructorReturn2 = __webpack_require__(14), _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2), _inherits2 = __webpack_require__(15), _inherits3 = _interopRequireDefault(_inherits2), _react = __webpack_require__(16), _react2 = _interopRequireDefault(_react), _DrawerTrigger = __webpack_require__(38), _DrawerTrigger2 = _interopRequireDefault(_DrawerTrigger), DrawerTrigger = function(_PureComponent) {
        function DrawerTrigger() {
            return (0, _classCallCheck3.default)(this, DrawerTrigger), (0, _possibleConstructorReturn3.default)(this, (DrawerTrigger.__proto__ || (0, 
            _getPrototypeOf2.default)(DrawerTrigger)).apply(this, arguments));
        }
        return (0, _inherits3.default)(DrawerTrigger, _PureComponent), (0, _createClass3.default)(DrawerTrigger, [ {
            key: "render",
            value: function() {
                return null === this.props.children ? null : _react2.default.createElement("button", {
                    "aria-haspopup": "true",
                    className: _DrawerTrigger2.default.drawerTrigger,
                    onClick: this.props.onActivate,
                    onMouseDown: function(e) {
                        return e.preventDefault();
                    }
                }, this.props.children);
            }
        } ]), DrawerTrigger;
    }(_react.PureComponent);
    DrawerTrigger.propTypes = {
        children: _react.PropTypes.node,
        onActivate: _react.PropTypes.func
    }, DrawerTrigger.defaultProps = {
        onActivate: function() {}
    }, exports.default = DrawerTrigger;
}, /* 38 */
/***/
function(module, exports, __webpack_require__) {
    // style-loader: Adds some css to the DOM by adding a <style> tag
    // load the styles
    var content = __webpack_require__(39);
    "string" == typeof content && (content = [ [ module.id, content, "" ] ]);
    // add the styles to the DOM
    __webpack_require__(20)(content, {});
    content.locals && (module.exports = content.locals);
}, /* 39 */
/***/
function(module, exports, __webpack_require__) {
    exports = module.exports = __webpack_require__(19)(), // imports
    // module
    exports.push([ module.id, "._3yyfQKnPmqb2fhl3czqmb8{display:-webkit-box;display:flex;-webkit-box-align:center;align-items:center;-webkit-box-pack:center;justify-content:center;margin:0;background:none;border:none;border-radius:50%;padding:0;width:40px;height:40px;outline:none;color:#fff}._3yyfQKnPmqb2fhl3czqmb8:focus{outline:none;box-shadow:0 0 0 2px #4c9aff}", "" ]), 
    // exports
    exports.locals = {
        drawerTrigger: "_3yyfQKnPmqb2fhl3czqmb8",
        drawerTrigger: "_3yyfQKnPmqb2fhl3czqmb8"
    };
}, /* 40 */
/***/
function(module, exports, __webpack_require__) {
    "use strict";
    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    Object.defineProperty(exports, "__esModule", {
        value: !0
    });
    var _defineProperty2 = __webpack_require__(22), _defineProperty3 = _interopRequireDefault(_defineProperty2), _getPrototypeOf = __webpack_require__(11), _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf), _classCallCheck2 = __webpack_require__(12), _classCallCheck3 = _interopRequireDefault(_classCallCheck2), _createClass2 = __webpack_require__(13), _createClass3 = _interopRequireDefault(_createClass2), _possibleConstructorReturn2 = __webpack_require__(14), _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2), _inherits2 = __webpack_require__(15), _inherits3 = _interopRequireDefault(_inherits2), _react = __webpack_require__(16), _react2 = _interopRequireDefault(_react), _classnames = __webpack_require__(23), _classnames2 = _interopRequireDefault(_classnames), _ContainerNavigation = __webpack_require__(41), _ContainerNavigation2 = _interopRequireDefault(_ContainerNavigation), _ContainerHeader = __webpack_require__(43), _ContainerHeader2 = _interopRequireDefault(_ContainerHeader), _DefaultLinkComponent = __webpack_require__(36), _DefaultLinkComponent2 = _interopRequireDefault(_DefaultLinkComponent), _GlobalActions = __webpack_require__(30), _GlobalActions2 = _interopRequireDefault(_GlobalActions), _sharedVariables = __webpack_require__(26), _Spacer = __webpack_require__(27), _Spacer2 = _interopRequireDefault(_Spacer), ContainerNavigation = function(_PureComponent) {
        function ContainerNavigation() {
            return (0, _classCallCheck3.default)(this, ContainerNavigation), (0, _possibleConstructorReturn3.default)(this, (ContainerNavigation.__proto__ || (0, 
            _getPrototypeOf2.default)(ContainerNavigation)).apply(this, arguments));
        }
        return (0, _inherits3.default)(ContainerNavigation, _PureComponent), (0, _createClass3.default)(ContainerNavigation, [ {
            key: "getOuterStyles",
            value: function() {
                return {
                    transform: "translateX(" + this.props.offsetX + "px)",
                    width: this.props.width
                };
            }
        }, {
            key: "render",
            value: function() {
                var _classNames2, _props = this.props, appearance = _props.appearance, areGlobalActionsVisible = _props.areGlobalActionsVisible, children = _props.children, globalCreateIcon = _props.globalCreateIcon, globalPrimaryIcon = _props.globalPrimaryIcon, globalPrimaryItemHref = _props.globalPrimaryItemHref, globalSearchIcon = _props.globalSearchIcon, headerComponent = _props.headerComponent, linkComponent = _props.linkComponent, offsetX = _props.offsetX, onGlobalCreateActivate = _props.onGlobalCreateActivate, onGlobalSearchActivate = _props.onGlobalSearchActivate, shouldAnimate = _props.shouldAnimate, width = _props.width, isWidthCollapsed = width <= _sharedVariables.containerClosedWidth;
                return _react2.default.createElement("div", {
                    className: (0, _classnames2.default)((0, _defineProperty3.default)({}, _ContainerNavigation2.default.shouldAnimate, shouldAnimate)),
                    "data-__ak-navigation-container-closed": isWidthCollapsed
                }, _react2.default.createElement(_Spacer2.default, {
                    shouldAnimate: shouldAnimate,
                    width: width + offsetX
                }), _react2.default.createElement("div", {
                    className: _ContainerNavigation2.default.containerNavigationOuter,
                    style: this.getOuterStyles()
                }, _react2.default.createElement("div", {
                    className: (0, _classnames2.default)(_ContainerNavigation2.default.containerNavigationInner, (_classNames2 = {}, 
                    (0, _defineProperty3.default)(_classNames2, _ContainerNavigation2.default.hasContainerHeader, null !== headerComponent), 
                    (0, _defineProperty3.default)(_classNames2, _ContainerNavigation2.default.hasGlobalAppearance, "global" === appearance), 
                    _classNames2))
                }, _react2.default.createElement(_GlobalActions2.default, {
                    appearance: "global" === appearance ? "global" : "container",
                    createIcon: globalCreateIcon,
                    isVisible: areGlobalActionsVisible,
                    linkComponent: linkComponent,
                    onCreateActivate: onGlobalCreateActivate,
                    onSearchActivate: onGlobalSearchActivate,
                    primaryIcon: globalPrimaryIcon,
                    primaryItemHref: globalPrimaryItemHref,
                    searchIcon: globalSearchIcon
                }), _react2.default.createElement("div", null, this.props.headerComponent ? _react2.default.createElement(_ContainerHeader2.default, null, this.props.headerComponent({
                    isCollapsed: width <= _sharedVariables.containerClosedWidth
                })) : null), _react2.default.createElement("div", null, children))));
            }
        } ]), ContainerNavigation;
    }(_react.PureComponent);
    ContainerNavigation.propTypes = {
        appearance: _react.PropTypes.string,
        areGlobalActionsVisible: _react.PropTypes.bool,
        children: _react.PropTypes.node,
        headerComponent: _react.PropTypes.func,
        shouldAnimate: _react.PropTypes.bool,
        width: _react.PropTypes.number,
        offsetX: _react.PropTypes.number,
        linkComponent: _react.PropTypes.func,
        globalPrimaryItemHref: _react.PropTypes.string,
        globalPrimaryIcon: _react.PropTypes.node,
        globalSearchIcon: _react.PropTypes.node,
        globalCreateIcon: _react.PropTypes.node,
        onGlobalCreateActivate: _react.PropTypes.func,
        onGlobalSearchActivate: _react.PropTypes.func
    }, ContainerNavigation.defaultProps = {
        appearance: "default",
        areGlobalActionsVisible: !1,
        shouldAnimate: !1,
        width: _sharedVariables.containerOpenWidth,
        offsetX: 0,
        linkComponent: _DefaultLinkComponent2.default
    }, exports.default = ContainerNavigation;
}, /* 41 */
/***/
function(module, exports, __webpack_require__) {
    // style-loader: Adds some css to the DOM by adding a <style> tag
    // load the styles
    var content = __webpack_require__(42);
    "string" == typeof content && (content = [ [ module.id, content, "" ] ]);
    // add the styles to the DOM
    __webpack_require__(20)(content, {});
    content.locals && (module.exports = content.locals);
}, /* 42 */
/***/
function(module, exports, __webpack_require__) {
    exports = module.exports = __webpack_require__(19)(), // imports
    // module
    exports.push([ module.id, "._1cJT7xBV76v6M29_c5xceD{height:100%;position:fixed}._5PB0664y6-VsYZE3ZUN3X ._1cJT7xBV76v6M29_c5xceD{-webkit-transition:width .2s,-webkit-transform .2s;transition:width .2s,-webkit-transform .2s;transition:width .2s,transform .2s;transition:width .2s,transform .2s,-webkit-transform .2s}._9iVSpHLMwf18APbGatyNp{box-sizing:border-box;background:#f4f5f7;color:#42526e;width:100%;height:100vh;overflow-x:hidden;overflow-y:auto;padding:16px 8px 0}._9iVSpHLMwf18APbGatyNp a,._9iVSpHLMwf18APbGatyNp a:hover,._9iVSpHLMwf18APbGatyNp a:visited{color:inherit;text-decoration:none}._9iVSpHLMwf18APbGatyNp:not(._1ErFL8UZ2DBl2ASjupIBDJ){padding-top:24px}._9iVSpHLMwf18APbGatyNp._3wFfg-mwlltmUCWy93P4IY{background-color:#0049b0;color:#fff}", "" ]), 
    // exports
    exports.locals = {
        containerNavigationOuter: "_1cJT7xBV76v6M29_c5xceD",
        containerNavigationOuter: "_1cJT7xBV76v6M29_c5xceD",
        "should-animate": "_5PB0664y6-VsYZE3ZUN3X",
        shouldAnimate: "_5PB0664y6-VsYZE3ZUN3X",
        containerNavigationInner: "_9iVSpHLMwf18APbGatyNp",
        containerNavigationInner: "_9iVSpHLMwf18APbGatyNp",
        hasContainerHeader: "_1ErFL8UZ2DBl2ASjupIBDJ",
        hasContainerHeader: "_1ErFL8UZ2DBl2ASjupIBDJ",
        hasGlobalAppearance: "_3wFfg-mwlltmUCWy93P4IY",
        hasGlobalAppearance: "_3wFfg-mwlltmUCWy93P4IY"
    };
}, /* 43 */
/***/
function(module, exports, __webpack_require__) {
    "use strict";
    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    Object.defineProperty(exports, "__esModule", {
        value: !0
    });
    var _getPrototypeOf = __webpack_require__(11), _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf), _classCallCheck2 = __webpack_require__(12), _classCallCheck3 = _interopRequireDefault(_classCallCheck2), _createClass2 = __webpack_require__(13), _createClass3 = _interopRequireDefault(_createClass2), _possibleConstructorReturn2 = __webpack_require__(14), _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2), _inherits2 = __webpack_require__(15), _inherits3 = _interopRequireDefault(_inherits2), _taggedTemplateLiteral2 = __webpack_require__(44), _taggedTemplateLiteral3 = _interopRequireDefault(_taggedTemplateLiteral2), _templateObject = (0, 
    _taggedTemplateLiteral3.default)([ "\n  transition: padding 200ms;\n  padding: ", ";\n  margin-bottom: ", 'px;\n\n  [data-__ak-navigation-container-closed="true"] & {\n    padding: ', ";\n  }\n" ], [ "\n  transition: padding 200ms;\n  padding: ", ";\n  margin-bottom: ", 'px;\n\n  [data-__ak-navigation-container-closed="true"] & {\n    padding: ', ";\n  }\n" ]), _react = __webpack_require__(16), _react2 = _interopRequireDefault(_react), _styledComponents = __webpack_require__(45), _styledComponents2 = _interopRequireDefault(_styledComponents), _utilSharedStyles = __webpack_require__(46), intGridSize = parseInt(_utilSharedStyles.akGridSize, 10), paddingOpen = "0 " + 1.75 * intGridSize + "px 0 " + 1.5 * intGridSize + "px", paddingClosed = "0 " + 2.5 * intGridSize + "px 0 " + .5 * intGridSize + "px", ContainerHeaderWrapper = _styledComponents2.default.div(_templateObject, paddingOpen, 1.5 * intGridSize, paddingClosed), ContainerHeader = function(_PureComponent) {
        function ContainerHeader() {
            return (0, _classCallCheck3.default)(this, ContainerHeader), (0, _possibleConstructorReturn3.default)(this, (ContainerHeader.__proto__ || (0, 
            _getPrototypeOf2.default)(ContainerHeader)).apply(this, arguments));
        }
        return (0, _inherits3.default)(ContainerHeader, _PureComponent), (0, _createClass3.default)(ContainerHeader, [ {
            key: "render",
            value: function() {
                return _react2.default.createElement(ContainerHeaderWrapper, null, this.props.children);
            }
        } ]), ContainerHeader;
    }(_react.PureComponent);
    ContainerHeader.propTypes = {
        children: _react.PropTypes.node
    }, exports.default = ContainerHeader;
}, /* 44 */
/***/
function(module, exports) {
    module.exports = require("babel-runtime/helpers/taggedTemplateLiteral");
}, /* 45 */
/***/
function(module, exports) {
    module.exports = require("styled-components");
}, /* 46 */
/***/
function(module, exports) {
    module.exports = require("@atlaskit/util-shared-styles");
}, /* 47 */
/***/
function(module, exports, __webpack_require__) {
    "use strict";
    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    Object.defineProperty(exports, "__esModule", {
        value: !0
    });
    var _getPrototypeOf = __webpack_require__(11), _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf), _classCallCheck2 = __webpack_require__(12), _classCallCheck3 = _interopRequireDefault(_classCallCheck2), _createClass2 = __webpack_require__(13), _createClass3 = _interopRequireDefault(_createClass2), _possibleConstructorReturn2 = __webpack_require__(14), _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2), _inherits2 = __webpack_require__(15), _inherits3 = _interopRequireDefault(_inherits2), _react = __webpack_require__(16), _react2 = _interopRequireDefault(_react), _Resizer = __webpack_require__(48), _Resizer2 = _interopRequireDefault(_Resizer), Resizer = function(_PureComponent) {
        function Resizer(props) {
            (0, _classCallCheck3.default)(this, Resizer);
            var _this = (0, _possibleConstructorReturn3.default)(this, (Resizer.__proto__ || (0, 
            _getPrototypeOf2.default)(Resizer)).call(this, props));
            return _this.mouseDownHandler = function(e) {
                _this.props.onResizeStart(), _this.setState({
                    startScreenX: e.screenX
                }), document.addEventListener("mousemove", _this.mouseMoveHandler), document.addEventListener("mouseup", _this.mouseUpHandler), 
                e.preventDefault();
            }, _this.mouseUpHandler = function(e) {
                _this.props.onResizeEnd(e.screenX - _this.state.startScreenX), document.removeEventListener("mousemove", _this.mouseMoveHandler), 
                document.removeEventListener("mouseup", _this.mouseUpHandler);
            }, _this.mouseMoveHandler = function(e) {
                _this.props.onResize(e.screenX - _this.state.startScreenX);
            }, _this.state = {
                startScreenX: 0
            }, _this;
        }
        return (0, _inherits3.default)(Resizer, _PureComponent), (0, _createClass3.default)(Resizer, [ {
            key: "render",
            value: function() {
                return _react2.default.createElement("div", {
                    className: _Resizer2.default.resizer,
                    onMouseDown: this.mouseDownHandler
                });
            }
        } ]), Resizer;
    }(_react.PureComponent);
    Resizer.propTypes = {
        onResizeStart: _react.PropTypes.func,
        onResize: _react.PropTypes.func,
        onResizeEnd: _react.PropTypes.func
    }, Resizer.defaultProps = {
        onResizeStart: function() {},
        onResize: function() {},
        onResizeEnd: function() {}
    }, exports.default = Resizer;
}, /* 48 */
/***/
function(module, exports, __webpack_require__) {
    // style-loader: Adds some css to the DOM by adding a <style> tag
    // load the styles
    var content = __webpack_require__(49);
    "string" == typeof content && (content = [ [ module.id, content, "" ] ]);
    // add the styles to the DOM
    __webpack_require__(20)(content, {});
    content.locals && (module.exports = content.locals);
}, /* 49 */
/***/
function(module, exports, __webpack_require__) {
    exports = module.exports = __webpack_require__(19)(), // imports
    // module
    exports.push([ module.id, ".NH8chnOTXu5MRAf6QusA0{height:100%;width:12px;position:relative;left:-6px;cursor:col-resize}.NH8chnOTXu5MRAf6QusA0:hover:before{background:#2684ff}.NH8chnOTXu5MRAf6QusA0:before{content:'';width:2px;height:100%;position:absolute;left:5px}", "" ]), 
    // exports
    exports.locals = {
        resizer: "NH8chnOTXu5MRAf6QusA0",
        resizer: "NH8chnOTXu5MRAf6QusA0"
    };
}, /* 50 */
/***/
function(module, exports, __webpack_require__) {
    "use strict";
    function getContainerWidth(navigationWidth) {
        return navigationWidth > _sharedVariables.collapseBreakpoint ? navigationWidth - _sharedVariables.globalOpenWidth : Math.max(0, _sharedVariables.containerClosedWidth);
    }
    Object.defineProperty(exports, "__esModule", {
        value: !0
    }), exports.default = getContainerWidth;
    var _sharedVariables = __webpack_require__(26);
}, /* 51 */
/***/
function(module, exports, __webpack_require__) {
    "use strict";
    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    Object.defineProperty(exports, "__esModule", {
        value: !0
    });
    var _defineProperty2 = __webpack_require__(22), _defineProperty3 = _interopRequireDefault(_defineProperty2), _getPrototypeOf = __webpack_require__(11), _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf), _classCallCheck2 = __webpack_require__(12), _classCallCheck3 = _interopRequireDefault(_classCallCheck2), _createClass2 = __webpack_require__(13), _createClass3 = _interopRequireDefault(_createClass2), _possibleConstructorReturn2 = __webpack_require__(14), _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2), _inherits2 = __webpack_require__(15), _inherits3 = _interopRequireDefault(_inherits2), _react = __webpack_require__(16), _react2 = _interopRequireDefault(_react), _ContainerItem = __webpack_require__(52), _classnames = __webpack_require__(23), _classnames2 = _interopRequireDefault(_classnames), _DefaultLinkComponent = __webpack_require__(36), _DefaultLinkComponent2 = _interopRequireDefault(_DefaultLinkComponent), _NavigationItem = __webpack_require__(54), _NavigationItem2 = _interopRequireDefault(_NavigationItem), ContainerItem = function(_PureComponent) {
        function ContainerItem() {
            return (0, _classCallCheck3.default)(this, ContainerItem), (0, _possibleConstructorReturn3.default)(this, (ContainerItem.__proto__ || (0, 
            _getPrototypeOf2.default)(ContainerItem)).apply(this, arguments));
        }
        return (0, _inherits3.default)(ContainerItem, _PureComponent), (0, _createClass3.default)(ContainerItem, [ {
            key: "render",
            value: function() {
                var _className;
                return _react2.default.createElement("div", {
                    className: (0, _classnames2.default)(_ContainerItem.containerItem, (_className = {}, 
                    (0, _defineProperty3.default)(_className, _ContainerItem.hasGlobalAppearance, "global" === this.props.appearance), 
                    (0, _defineProperty3.default)(_className, _ContainerItem.isSelected, this.props.isSelected), 
                    _className))
                }, _react2.default.createElement(_NavigationItem2.default, {
                    action: this.props.action,
                    href: this.props.href,
                    icon: this.props.icon,
                    isCompact: this.props.isCompact,
                    isSelected: this.props.isSelected,
                    linkComponent: this.props.linkComponent,
                    onClick: this.props.onClick,
                    subText: this.props.subText,
                    text: this.props.text,
                    textAfter: this.props.textAfter
                }));
            }
        } ]), ContainerItem;
    }(_react.PureComponent);
    ContainerItem.propTypes = {
        action: _react.PropTypes.node,
        appearance: _react.PropTypes.string,
        href: _react.PropTypes.string,
        icon: _react.PropTypes.node,
        isCompact: _react.PropTypes.bool,
        isSelected: _react.PropTypes.bool,
        linkComponent: _react.PropTypes.func,
        onClick: _react.PropTypes.func,
        subText: _react.PropTypes.string,
        text: _react.PropTypes.node,
        textAfter: _react.PropTypes.node
    }, ContainerItem.defaultProps = {
        isCompact: !1,
        isSelected: !1,
        linkComponent: _DefaultLinkComponent2.default
    }, exports.default = ContainerItem;
}, /* 52 */
/***/
function(module, exports, __webpack_require__) {
    // style-loader: Adds some css to the DOM by adding a <style> tag
    // load the styles
    var content = __webpack_require__(53);
    "string" == typeof content && (content = [ [ module.id, content, "" ] ]);
    // add the styles to the DOM
    __webpack_require__(20)(content, {});
    content.locals && (module.exports = content.locals);
}, /* 53 */
/***/
function(module, exports, __webpack_require__) {
    exports = module.exports = __webpack_require__(19)(), // imports
    // module
    exports.push([ module.id, "._322BGr1xoQTRp2egQ63Z1k{border-radius:3px}._322BGr1xoQTRp2egQ63Z1k.x4SZLIkzNGSIwxQWOLpE7,._322BGr1xoQTRp2egQ63Z1k:hover{background:rgba(9,30,66,.04)}._322BGr1xoQTRp2egQ63Z1k.x4SZLIkzNGSIwxQWOLpE7.GWkufuAWw9-y3brTRBLis,._322BGr1xoQTRp2egQ63Z1k:hover.GWkufuAWw9-y3brTRBLis{color:#fff;background:rgba(9,30,66,.25)}.x4SZLIkzNGSIwxQWOLpE7{color:#0052cc}", "" ]), 
    // exports
    exports.locals = {
        containerItem: "_322BGr1xoQTRp2egQ63Z1k",
        containerItem: "_322BGr1xoQTRp2egQ63Z1k",
        isSelected: "x4SZLIkzNGSIwxQWOLpE7",
        isSelected: "x4SZLIkzNGSIwxQWOLpE7",
        hasGlobalAppearance: "GWkufuAWw9-y3brTRBLis",
        hasGlobalAppearance: "GWkufuAWw9-y3brTRBLis"
    };
}, /* 54 */
/***/
function(module, exports, __webpack_require__) {
    "use strict";
    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    Object.defineProperty(exports, "__esModule", {
        value: !0
    });
    var _defineProperty2 = __webpack_require__(22), _defineProperty3 = _interopRequireDefault(_defineProperty2), _getPrototypeOf = __webpack_require__(11), _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf), _classCallCheck2 = __webpack_require__(12), _classCallCheck3 = _interopRequireDefault(_classCallCheck2), _createClass2 = __webpack_require__(13), _createClass3 = _interopRequireDefault(_createClass2), _possibleConstructorReturn2 = __webpack_require__(14), _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2), _inherits2 = __webpack_require__(15), _inherits3 = _interopRequireDefault(_inherits2), _react = __webpack_require__(16), _react2 = _interopRequireDefault(_react), _NavigationItem = __webpack_require__(55), _classnames = __webpack_require__(23), _classnames2 = _interopRequireDefault(_classnames), _DefaultLinkComponent = __webpack_require__(36), _DefaultLinkComponent2 = _interopRequireDefault(_DefaultLinkComponent), _InteractiveWrapper = __webpack_require__(57), _InteractiveWrapper2 = _interopRequireDefault(_InteractiveWrapper), NavigationItem = function(_PureComponent) {
        function NavigationItem() {
            var _ref, _temp, _this, _ret;
            (0, _classCallCheck3.default)(this, NavigationItem);
            for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) args[_key] = arguments[_key];
            return _temp = _this = (0, _possibleConstructorReturn3.default)(this, (_ref = NavigationItem.__proto__ || (0, 
            _getPrototypeOf2.default)(NavigationItem)).call.apply(_ref, [ this ].concat(args))), 
            _this.onMouseDown = function(e) {
                e.preventDefault();
            }, _ret = _temp, (0, _possibleConstructorReturn3.default)(_this, _ret);
        }
        return (0, _inherits3.default)(NavigationItem, _PureComponent), (0, _createClass3.default)(NavigationItem, [ {
            key: "render",
            value: function() {
                var _classNames, _this2 = this, Icon = function() {
                    return _this2.props.icon ? _react2.default.createElement("div", {
                        className: _NavigationItem.icon
                    }, _this2.props.icon) : null;
                }, TextAfter = function() {
                    return _this2.props.textAfter ? _react2.default.createElement("div", {
                        className: _NavigationItem.textAfter
                    }, _this2.props.textAfter) : null;
                }, Action = function() {
                    return _this2.props.action ? _react2.default.createElement("div", {
                        className: _NavigationItem.action
                    }, _this2.props.action) : null;
                }, After = function(_ref2) {
                    var children = _ref2.children;
                    return _this2.props.textAfter ? _react2.default.createElement("div", {
                        className: _NavigationItem.after
                    }, children) : null;
                };
                return _react2.default.createElement("div", {
                    className: (0, _classnames2.default)(_NavigationItem.navigationItemOuter, (_classNames = {}, 
                    (0, _defineProperty3.default)(_classNames, _NavigationItem.isSelected, this.props.isSelected), 
                    (0, _defineProperty3.default)(_classNames, _NavigationItem.isCompact, this.props.isCompact), 
                    _classNames))
                }, _react2.default.createElement(_InteractiveWrapper2.default, {
                    className: _NavigationItem.link,
                    href: this.props.href,
                    onMouseDown: this.onMouseDown,
                    onClick: this.props.onClick,
                    linkComponent: this.props.linkComponent
                }, _react2.default.createElement("div", {
                    className: _NavigationItem.navigationItemInner
                }, _react2.default.createElement(Icon, null), _react2.default.createElement("div", {
                    className: _NavigationItem.text
                }, _react2.default.createElement("div", {
                    className: _NavigationItem.mainText
                }, this.props.text), _react2.default.createElement("div", {
                    className: _NavigationItem.subText
                }, this.props.subText)), _react2.default.createElement(After, null, _react2.default.createElement(TextAfter, null)))), _react2.default.createElement(Action, null));
            }
        } ]), NavigationItem;
    }(_react.PureComponent);
    NavigationItem.propTypes = {
        action: _react.PropTypes.node,
        href: _react.PropTypes.string,
        icon: _react.PropTypes.node,
        isCompact: _react.PropTypes.bool,
        isSelected: _react.PropTypes.bool,
        linkComponent: _react.PropTypes.func,
        onClick: _react.PropTypes.func,
        subText: _react.PropTypes.string,
        text: _react.PropTypes.node,
        textAfter: _react.PropTypes.node
    }, NavigationItem.defaultProps = {
        isCompact: !1,
        isSelected: !1,
        linkComponent: _DefaultLinkComponent2.default
    }, exports.default = NavigationItem;
}, /* 55 */
/***/
function(module, exports, __webpack_require__) {
    // style-loader: Adds some css to the DOM by adding a <style> tag
    // load the styles
    var content = __webpack_require__(56);
    "string" == typeof content && (content = [ [ module.id, content, "" ] ]);
    // add the styles to the DOM
    __webpack_require__(20)(content, {});
    content.locals && (module.exports = content.locals);
}, /* 56 */
/***/
function(module, exports, __webpack_require__) {
    exports = module.exports = __webpack_require__(19)(), // imports
    // module
    exports.push([ module.id, "._1Oh9qqLDJe3gLw8EuqBpbT{width:100%;height:40px;box-sizing:border-box;text-overflow:ellipsis;position:relative}._1Oh9qqLDJe3gLw8EuqBpbT .i7Kv76Dhl1puO7-XRtX0q{padding:0}._1Oh9qqLDJe3gLw8EuqBpbT:hover ._1Oh9qqLDJe3gLw8EuqBpbT.i7Kv76Dhl1puO7-XRtX0q{padding:0}._1Oh9qqLDJe3gLw8EuqBpbT a,._1Oh9qqLDJe3gLw8EuqBpbT a:hover,._1Oh9qqLDJe3gLw8EuqBpbT a:visited{color:inherit;text-decoration:none}._1kh5nCnPJM-4_JX6R-naqj ._33bCUXayXvNgEDo8GMVx6E{padding-left:0;padding-right:8px}._2ZVgiKgXKsmlu7f9l2SMDV{height:100%;width:100%;padding:0 8px;display:-webkit-box;display:flex;-webkit-box-align:center;align-items:center;box-sizing:border-box}._1kh5nCnPJM-4_JX6R-naqj{height:36px}._1kh5nCnPJM-4_JX6R-naqj ._2J_CHffQZJZuhwjIOaVE8M{font-size:10px;line-height:12px}._3AbUw0bqsfvUUk0yIF3Dcd:focus{display:block;height:100%;border-radius:3px}._3AbUw0bqsfvUUk0yIF3Dcd:focus:focus{outline:none;box-shadow:0 0 0 2px #4c9aff}._3O_4fJy0gpfR8vmFmursaD{display:-webkit-box;display:flex;height:100%;-webkit-box-pack:center;justify-content:center;position:absolute;right:8px;top:0}[data-__ak-navigation-container-closed=true] ._3O_4fJy0gpfR8vmFmursaD{opacity:0}._33bCUXayXvNgEDo8GMVx6E{-webkit-transition:padding .2s;transition:padding .2s;padding:0 24px 0 12px;display:-webkit-box;display:flex}[data-__ak-navigation-container-closed=true] ._33bCUXayXvNgEDo8GMVx6E{padding:0 4px}._33bCUXayXvNgEDo8GMVx6E>*{width:24px;height:24px}._1tQPAqQB579HbNfOetZH0m{min-width:24px}._1A6niKSvklIP6KW7LMLlcN{overflow-x:hidden;display:inline-block;-webkit-box-flex:1;flex-grow:1}[data-__ak-navigation-container-closed=true] ._1A6niKSvklIP6KW7LMLlcN{opacity:0}._1A6niKSvklIP6KW7LMLlcN.PzTv1anGAvbzXjj-bXDjp{margin-right:24px}.wltVJTB5dEjreFmtdDYmS{overflow-x:hidden;text-overflow:ellipsis;white-space:nowrap}._2J_CHffQZJZuhwjIOaVE8M{color:#8993a4;font-size:.85714286em;overflow-x:hidden;text-overflow:ellipsis;white-space:nowrap}._1hTFtQQFtVExAf9FDezJ72{position:relative;z-index:1}[data-__ak-navigation-container-closed=true] ._1hTFtQQFtVExAf9FDezJ72{opacity:0}", "" ]), 
    // exports
    exports.locals = {
        navigationItemOuter: "_1Oh9qqLDJe3gLw8EuqBpbT",
        navigationItemOuter: "_1Oh9qqLDJe3gLw8EuqBpbT",
        isSelected: "i7Kv76Dhl1puO7-XRtX0q",
        isSelected: "i7Kv76Dhl1puO7-XRtX0q",
        isCompact: "_1kh5nCnPJM-4_JX6R-naqj",
        isCompact: "_1kh5nCnPJM-4_JX6R-naqj",
        icon: "_33bCUXayXvNgEDo8GMVx6E",
        icon: "_33bCUXayXvNgEDo8GMVx6E",
        navigationItemInner: "_2ZVgiKgXKsmlu7f9l2SMDV",
        navigationItemInner: "_2ZVgiKgXKsmlu7f9l2SMDV",
        subText: "_2J_CHffQZJZuhwjIOaVE8M",
        subText: "_2J_CHffQZJZuhwjIOaVE8M",
        link: "_3AbUw0bqsfvUUk0yIF3Dcd",
        link: "_3AbUw0bqsfvUUk0yIF3Dcd",
        action: "_3O_4fJy0gpfR8vmFmursaD",
        action: "_3O_4fJy0gpfR8vmFmursaD",
        after: "_1tQPAqQB579HbNfOetZH0m",
        after: "_1tQPAqQB579HbNfOetZH0m",
        text: "_1A6niKSvklIP6KW7LMLlcN",
        text: "_1A6niKSvklIP6KW7LMLlcN",
        hasTextAfterOrAction: "PzTv1anGAvbzXjj-bXDjp",
        hasTextAfterOrAction: "PzTv1anGAvbzXjj-bXDjp",
        mainText: "wltVJTB5dEjreFmtdDYmS",
        mainText: "wltVJTB5dEjreFmtdDYmS",
        textAfter: "_1hTFtQQFtVExAf9FDezJ72",
        textAfter: "_1hTFtQQFtVExAf9FDezJ72"
    };
}, /* 57 */
/***/
function(module, exports, __webpack_require__) {
    "use strict";
    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    Object.defineProperty(exports, "__esModule", {
        value: !0
    });
    var _getPrototypeOf = __webpack_require__(11), _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf), _classCallCheck2 = __webpack_require__(12), _classCallCheck3 = _interopRequireDefault(_classCallCheck2), _createClass2 = __webpack_require__(13), _createClass3 = _interopRequireDefault(_createClass2), _possibleConstructorReturn2 = __webpack_require__(14), _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2), _inherits2 = __webpack_require__(15), _inherits3 = _interopRequireDefault(_inherits2), _taggedTemplateLiteral2 = __webpack_require__(44), _taggedTemplateLiteral3 = _interopRequireDefault(_taggedTemplateLiteral2), _templateObject = (0, 
    _taggedTemplateLiteral3.default)([ "\n  align-items: inherit;\n  background: none;\n  border: none;\n  box-sizing: content-box;\n  color: inherit;\n  cursor: pointer;\n  display: inline;\n  font: inherit;\n  height: 100%;\n  line-height: normal;\n  padding: 0;\n  text-align: inherit;\n  width: 100%;\n" ], [ "\n  align-items: inherit;\n  background: none;\n  border: none;\n  box-sizing: content-box;\n  color: inherit;\n  cursor: pointer;\n  display: inline;\n  font: inherit;\n  height: 100%;\n  line-height: normal;\n  padding: 0;\n  text-align: inherit;\n  width: 100%;\n" ]), _react = __webpack_require__(16), _react2 = _interopRequireDefault(_react), _styledComponents = __webpack_require__(45), _styledComponents2 = _interopRequireDefault(_styledComponents), InvisibleButton = _styledComponents2.default.button(_templateObject), InteractiveWrapper = function(_PureComponent) {
        function InteractiveWrapper() {
            return (0, _classCallCheck3.default)(this, InteractiveWrapper), (0, _possibleConstructorReturn3.default)(this, (InteractiveWrapper.__proto__ || (0, 
            _getPrototypeOf2.default)(InteractiveWrapper)).apply(this, arguments));
        }
        return (0, _inherits3.default)(InteractiveWrapper, _PureComponent), (0, _createClass3.default)(InteractiveWrapper, [ {
            key: "render",
            value: function() {
                var _props = this.props, children = _props.children, className = _props.className, href = _props.href, LinkComponent = _props.linkComponent, onClick = _props.onClick, onMouseDown = _props.onMouseDown;
                return href ? _react2.default.createElement(LinkComponent, {
                    onMouseDown: onMouseDown,
                    onClick: onClick,
                    href: href,
                    className: className
                }, children) : _react2.default.createElement(InvisibleButton, {
                    className: className,
                    onClick: onClick,
                    onMouseDown: onMouseDown
                }, children);
            }
        } ]), InteractiveWrapper;
    }(_react.PureComponent);
    InteractiveWrapper.propTypes = {
        children: _react.PropTypes.node,
        className: _react.PropTypes.string,
        href: _react.PropTypes.string,
        linkComponent: _react.PropTypes.func,
        onClick: _react.PropTypes.func,
        onMouseDown: _react.PropTypes.func
    }, exports.default = InteractiveWrapper;
}, /* 58 */
/***/
function(module, exports, __webpack_require__) {
    "use strict";
    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    Object.defineProperty(exports, "__esModule", {
        value: !0
    });
    var _defineProperty2 = __webpack_require__(22), _defineProperty3 = _interopRequireDefault(_defineProperty2), _getPrototypeOf = __webpack_require__(11), _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf), _classCallCheck2 = __webpack_require__(12), _classCallCheck3 = _interopRequireDefault(_classCallCheck2), _createClass2 = __webpack_require__(13), _createClass3 = _interopRequireDefault(_createClass2), _possibleConstructorReturn2 = __webpack_require__(14), _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2), _inherits2 = __webpack_require__(15), _inherits3 = _interopRequireDefault(_inherits2), _react = __webpack_require__(16), _react2 = _interopRequireDefault(_react), _ContainerItemGroup = __webpack_require__(59), _ContainerItemGroup2 = _interopRequireDefault(_ContainerItemGroup), _classnames = __webpack_require__(23), _classnames2 = _interopRequireDefault(_classnames), ContainerItemGroup = function(_PureComponent) {
        function ContainerItemGroup() {
            return (0, _classCallCheck3.default)(this, ContainerItemGroup), (0, _possibleConstructorReturn3.default)(this, (ContainerItemGroup.__proto__ || (0, 
            _getPrototypeOf2.default)(ContainerItemGroup)).apply(this, arguments));
        }
        return (0, _inherits3.default)(ContainerItemGroup, _PureComponent), (0, _createClass3.default)(ContainerItemGroup, [ {
            key: "render",
            value: function() {
                var _props = this.props, title = _props.title, action = _props.action, Title = function() {
                    return title ? _react2.default.createElement("div", {
                        className: _ContainerItemGroup2.default.title
                    }, _react2.default.createElement("span", null, title)) : null;
                };
                return _react2.default.createElement("div", {
                    className: (0, _classnames2.default)((0, _defineProperty3.default)({}, _ContainerItemGroup2.default.noHeaderContent, !(title || action)))
                }, title || action ? _react2.default.createElement("div", {
                    className: _ContainerItemGroup2.default.header
                }, _react2.default.createElement(Title, null), this.props.action ? _react2.default.createElement("div", {
                    className: _ContainerItemGroup2.default.action
                }, this.props.action) : null) : null, _react2.default.createElement("div", null, this.props.children));
            }
        } ]), ContainerItemGroup;
    }(_react.PureComponent);
    ContainerItemGroup.propTypes = {
        action: _react.PropTypes.node,
        children: _react.PropTypes.node,
        title: _react.PropTypes.string
    }, exports.default = ContainerItemGroup;
}, /* 59 */
/***/
function(module, exports, __webpack_require__) {
    // style-loader: Adds some css to the DOM by adding a <style> tag
    // load the styles
    var content = __webpack_require__(60);
    "string" == typeof content && (content = [ [ module.id, content, "" ] ]);
    // add the styles to the DOM
    __webpack_require__(20)(content, {});
    content.locals && (module.exports = content.locals);
}, /* 60 */
/***/
function(module, exports, __webpack_require__) {
    exports = module.exports = __webpack_require__(19)(), // imports
    // module
    exports.push([ module.id, "._2J9VO0Rfu09mfb1pIDGhf4{display:-webkit-box;display:flex;margin-bottom:8px;margin-left:8px;margin-top:16px}[data-__ak-navigation-container-closed=true] ._2J9VO0Rfu09mfb1pIDGhf4{margin-left:4px;margin-right:4px;border-top:1px solid rgba(9,30,66,.13)}[data-__ak-navigation-container-closed=true] ._2J9VO0Rfu09mfb1pIDGhf4 ._2ZXa9epZxNG6HO2WAWkmnk,[data-__ak-navigation-container-closed=true] ._2J9VO0Rfu09mfb1pIDGhf4 ._3CPoqwJOpLT85seuZ2qhuz{visibility:hidden}._2y2JU1Fv-n9zZbqSuh_6-k{margin-top:24px}._2ZXa9epZxNG6HO2WAWkmnk{align-self:center;color:#8993a4;display:-webkit-box;display:flex;-webkit-box-flex:1;flex-grow:1;font-size:12px;text-transform:uppercase}._3CPoqwJOpLT85seuZ2qhuz{margin-right:8px}", "" ]), 
    // exports
    exports.locals = {
        header: "_2J9VO0Rfu09mfb1pIDGhf4",
        header: "_2J9VO0Rfu09mfb1pIDGhf4",
        title: "_2ZXa9epZxNG6HO2WAWkmnk",
        title: "_2ZXa9epZxNG6HO2WAWkmnk",
        action: "_3CPoqwJOpLT85seuZ2qhuz",
        action: "_3CPoqwJOpLT85seuZ2qhuz",
        noHeaderContent: "_2y2JU1Fv-n9zZbqSuh_6-k",
        noHeaderContent: "_2y2JU1Fv-n9zZbqSuh_6-k"
    };
}, /* 61 */
/***/
function(module, exports, __webpack_require__) {
    "use strict";
    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    Object.defineProperty(exports, "__esModule", {
        value: !0
    });
    var _getPrototypeOf = __webpack_require__(11), _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf), _classCallCheck2 = __webpack_require__(12), _classCallCheck3 = _interopRequireDefault(_classCallCheck2), _createClass2 = __webpack_require__(13), _createClass3 = _interopRequireDefault(_createClass2), _possibleConstructorReturn2 = __webpack_require__(14), _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2), _inherits2 = __webpack_require__(15), _inherits3 = _interopRequireDefault(_inherits2), _react = __webpack_require__(16), _react2 = _interopRequireDefault(_react), _ContainerLogo = __webpack_require__(62), _ContainerLogo2 = _interopRequireDefault(_ContainerLogo), ContainerLogo = function(_PureComponent) {
        function ContainerLogo() {
            return (0, _classCallCheck3.default)(this, ContainerLogo), (0, _possibleConstructorReturn3.default)(this, (ContainerLogo.__proto__ || (0, 
            _getPrototypeOf2.default)(ContainerLogo)).apply(this, arguments));
        }
        return (0, _inherits3.default)(ContainerLogo, _PureComponent), (0, _createClass3.default)(ContainerLogo, [ {
            key: "render",
            value: function() {
                return _react2.default.createElement("div", {
                    className: _ContainerLogo2.default.containerLogo
                }, this.props.children);
            }
        } ]), ContainerLogo;
    }(_react.PureComponent);
    ContainerLogo.propTypes = {
        children: _react.PropTypes.node
    }, exports.default = ContainerLogo;
}, /* 62 */
/***/
function(module, exports, __webpack_require__) {
    // style-loader: Adds some css to the DOM by adding a <style> tag
    // load the styles
    var content = __webpack_require__(63);
    "string" == typeof content && (content = [ [ module.id, content, "" ] ]);
    // add the styles to the DOM
    __webpack_require__(20)(content, {});
    content.locals && (module.exports = content.locals);
}, /* 63 */
/***/
function(module, exports, __webpack_require__) {
    exports = module.exports = __webpack_require__(19)(), // imports
    // module
    exports.push([ module.id, ".MFlHA1nfIQBNEmEPqEHl{height:24px;margin:28px 0 28px 24px}", "" ]), 
    // exports
    exports.locals = {
        containerLogo: "MFlHA1nfIQBNEmEPqEHl",
        containerLogo: "MFlHA1nfIQBNEmEPqEHl"
    };
}, /* 64 */
/***/
function(module, exports, __webpack_require__) {
    "use strict";
    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    Object.defineProperty(exports, "__esModule", {
        value: !0
    });
    var _getPrototypeOf = __webpack_require__(11), _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf), _classCallCheck2 = __webpack_require__(12), _classCallCheck3 = _interopRequireDefault(_classCallCheck2), _createClass2 = __webpack_require__(13), _createClass3 = _interopRequireDefault(_createClass2), _possibleConstructorReturn2 = __webpack_require__(14), _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2), _inherits2 = __webpack_require__(15), _inherits3 = _interopRequireDefault(_inherits2), _react = __webpack_require__(16), _react2 = _interopRequireDefault(_react), _ContainerTitle = __webpack_require__(65), _ContainerTitle2 = _interopRequireDefault(_ContainerTitle), _DefaultLinkComponent = __webpack_require__(36), _DefaultLinkComponent2 = _interopRequireDefault(_DefaultLinkComponent), ContainerTitle = function(_PureComponent) {
        function ContainerTitle() {
            return (0, _classCallCheck3.default)(this, ContainerTitle), (0, _possibleConstructorReturn3.default)(this, (ContainerTitle.__proto__ || (0, 
            _getPrototypeOf2.default)(ContainerTitle)).apply(this, arguments));
        }
        return (0, _inherits3.default)(ContainerTitle, _PureComponent), (0, _createClass3.default)(ContainerTitle, [ {
            key: "render",
            value: function() {
                var _props = this.props, href = _props.href, text = _props.text, Link = _props.linkComponent;
                return _react2.default.createElement(Link, {
                    className: _ContainerTitle2.default.link,
                    href: href
                }, _react2.default.createElement("div", {
                    className: _ContainerTitle2.default.containerTitle
                }, _react2.default.createElement("div", {
                    className: _ContainerTitle2.default.icon
                }, this.props.icon), _react2.default.createElement("div", {
                    className: _ContainerTitle2.default.text
                }, " ", text, " ")));
            }
        } ]), ContainerTitle;
    }(_react.PureComponent);
    ContainerTitle.propTypes = {
        icon: _react.PropTypes.node,
        text: _react.PropTypes.string,
        href: _react.PropTypes.string,
        linkComponent: _react.PropTypes.func
    }, ContainerTitle.defaultProps = {
        linkComponent: _DefaultLinkComponent2.default
    }, exports.default = ContainerTitle;
}, /* 65 */
/***/
function(module, exports, __webpack_require__) {
    // style-loader: Adds some css to the DOM by adding a <style> tag
    // load the styles
    var content = __webpack_require__(66);
    "string" == typeof content && (content = [ [ module.id, content, "" ] ]);
    // add the styles to the DOM
    __webpack_require__(20)(content, {});
    content.locals && (module.exports = content.locals);
}, /* 66 */
/***/
function(module, exports, __webpack_require__) {
    exports = module.exports = __webpack_require__(19)(), // imports
    // module
    exports.push([ module.id, ".MwO1hh01pSM2mVaQmhznU{display:-webkit-box;display:flex;-webkit-box-align:center;align-items:center;align-content:center;padding-top:4px}._1x99VVP68BnGb7focOk32E{color:#505f79;text-decoration:none;font-weight:500}._1x99VVP68BnGb7focOk32E:hover{color:#505f79;text-decoration:none}.Zv8HmryFESWmhki2p_bzI>*{width:40px;height:40px;border-radius:4px}.CQIVMU9TM4MhQDc41xcYl{margin-left:16px}", "" ]), 
    // exports
    exports.locals = {
        containerTitle: "MwO1hh01pSM2mVaQmhznU",
        containerTitle: "MwO1hh01pSM2mVaQmhznU",
        link: "_1x99VVP68BnGb7focOk32E",
        link: "_1x99VVP68BnGb7focOk32E",
        icon: "Zv8HmryFESWmhki2p_bzI",
        icon: "Zv8HmryFESWmhki2p_bzI",
        text: "CQIVMU9TM4MhQDc41xcYl",
        text: "CQIVMU9TM4MhQDc41xcYl"
    };
}, /* 67 */
/***/
function(module, exports, __webpack_require__) {
    "use strict";
    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    Object.defineProperty(exports, "__esModule", {
        value: !0
    });
    var _getPrototypeOf = __webpack_require__(11), _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf), _classCallCheck2 = __webpack_require__(12), _classCallCheck3 = _interopRequireDefault(_classCallCheck2), _createClass2 = __webpack_require__(13), _createClass3 = _interopRequireDefault(_createClass2), _possibleConstructorReturn2 = __webpack_require__(14), _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2), _inherits2 = __webpack_require__(15), _inherits3 = _interopRequireDefault(_inherits2), _react = __webpack_require__(16), _react2 = _interopRequireDefault(_react), _ContainerNavigationNested = __webpack_require__(68), _ContainerNavigationNested2 = _interopRequireDefault(_ContainerNavigationNested), ContainerNavigationNested = function(_PureComponent) {
        function ContainerNavigationNested(props) {
            (0, _classCallCheck3.default)(this, ContainerNavigationNested);
            var _this = (0, _possibleConstructorReturn3.default)(this, (ContainerNavigationNested.__proto__ || (0, 
            _getPrototypeOf2.default)(ContainerNavigationNested)).call(this, props));
            return _this.animationEndHandler = function() {
                "left" === _this.props.animationDirection ? (_this.animateContainer.classList.remove(_ContainerNavigationNested2.default.containerNavigationNestedLeftAnimate), 
                _this.animateContainer.classList.add(_ContainerNavigationNested2.default.containerNavigationNestedLeftAnimateEnd)) : (_this.animateContainer.classList.remove(_ContainerNavigationNested2.default.containerNavigationNestedRightAnimate), 
                _this.animateContainer.classList.add(_ContainerNavigationNested2.default.containerNavigationNestedRightAnimateEnd)), 
                _this.props.onAnimationEnd();
            }, _this.state = {}, _this;
        }
        return (0, _inherits3.default)(ContainerNavigationNested, _PureComponent), (0, _createClass3.default)(ContainerNavigationNested, [ {
            key: "componentWillUpdate",
            value: function(nextProps) {
                nextProps.children !== this.props.children && this.setState({
                    prevChildren: this.props.children
                });
            }
        }, {
            key: "componentDidUpdate",
            value: function() {
                this.animateContainer.className = _ContainerNavigationNested2.default.containerNavigationNested, 
                // handle left animation
                "left" === this.props.animationDirection && this.animateContainer.classList.add(_ContainerNavigationNested2.default.containerNavigationNestedLeftAnimate), 
                // handle right animation
                "right" === this.props.animationDirection && this.animateContainer.classList.add(_ContainerNavigationNested2.default.containerNavigationNestedRightAnimate);
            }
        }, {
            key: "render",
            value: function() {
                var _this2 = this, children = this.props.children, prevChildren = this.state.prevChildren, activePane = _react2.default.createElement("div", {
                    key: "active-pane",
                    className: _ContainerNavigationNested2.default.pageWrapper
                }, children), prevPane = _react2.default.createElement("div", {
                    key: "prev-pane",
                    className: _ContainerNavigationNested2.default.pageWrapper
                }, prevChildren), content = "left" === this.props.animationDirection ? [ prevPane, activePane ] : [ activePane, prevPane ];
                return _react2.default.createElement("div", {
                    className: _ContainerNavigationNested2.default.containerNavigationNested,
                    onAnimationEnd: this.animationEndHandler,
                    ref: function(el) {
                        _this2.animateContainer = el;
                    }
                }, content);
            }
        } ]), ContainerNavigationNested;
    }(_react.PureComponent);
    ContainerNavigationNested.propTypes = {
        children: _react.PropTypes.node,
        onAnimationEnd: _react.PropTypes.func,
        animationDirection: _react.PropTypes.oneOf([ "left", "right" ])
    }, ContainerNavigationNested.defaultProps = {
        onAnimationEnd: function() {}
    }, exports.default = ContainerNavigationNested;
}, /* 68 */
/***/
function(module, exports, __webpack_require__) {
    // style-loader: Adds some css to the DOM by adding a <style> tag
    // load the styles
    var content = __webpack_require__(69);
    "string" == typeof content && (content = [ [ module.id, content, "" ] ]);
    // add the styles to the DOM
    __webpack_require__(20)(content, {});
    content.locals && (module.exports = content.locals);
}, /* 69 */
/***/
function(module, exports, __webpack_require__) {
    exports = module.exports = __webpack_require__(19)(), // imports
    // module
    exports.push([ module.id, "._1rPnnkMv6Q3YeXXnOGq40W{display:-webkit-box;display:flex;position:relative}._2168WENQSJlKVdD65sh6R2{-webkit-animation-name:PCqvR3D_R6PWZW7nOhW7d;animation-name:PCqvR3D_R6PWZW7nOhW7d;-webkit-animation-duration:.3s;animation-duration:.3s;-webkit-animation-fill-mode:forwards;animation-fill-mode:forwards}._2KlUqnpO-sFO4Ka05slPvH{-webkit-transform:translateX(-100%);transform:translateX(-100%)}@-webkit-keyframes PCqvR3D_R6PWZW7nOhW7d{0%{-webkit-transform:translateX(0);transform:translateX(0)}to{-webkit-transform:translateX(-100%);transform:translateX(-100%)}}@keyframes PCqvR3D_R6PWZW7nOhW7d{0%{-webkit-transform:translateX(0);transform:translateX(0)}to{-webkit-transform:translateX(-100%);transform:translateX(-100%)}}._3aMB2WpzWrSqUT750siuEu{-webkit-animation-name:_3EoBuHiCPCD_K6gFwWM1aV;animation-name:_3EoBuHiCPCD_K6gFwWM1aV;-webkit-animation-duration:.3s;animation-duration:.3s;-webkit-animation-fill-mode:forwards;animation-fill-mode:forwards}._2Woab7GuLxmrxBxEwCNQ83{-webkit-transform:translateX(0);transform:translateX(0)}@-webkit-keyframes _3EoBuHiCPCD_K6gFwWM1aV{0%{-webkit-transform:translateX(-100%);transform:translateX(-100%)}to{-webkit-transform:translateX(0);transform:translateX(0)}}@keyframes _3EoBuHiCPCD_K6gFwWM1aV{0%{-webkit-transform:translateX(-100%);transform:translateX(-100%)}to{-webkit-transform:translateX(0);transform:translateX(0)}}.yJQWWPBsTHTujGQHFrHxA{-webkit-box-flex:1;flex:1 0 100%;overflow:hidden;box-sizing:border-box}", "" ]), 
    // exports
    exports.locals = {
        containerNavigationNested: "_1rPnnkMv6Q3YeXXnOGq40W",
        containerNavigationNested: "_1rPnnkMv6Q3YeXXnOGq40W",
        containerNavigationNestedLeftAnimate: "_2168WENQSJlKVdD65sh6R2",
        containerNavigationNestedLeftAnimate: "_2168WENQSJlKVdD65sh6R2",
        slideLeft: "PCqvR3D_R6PWZW7nOhW7d",
        slideLeft: "PCqvR3D_R6PWZW7nOhW7d",
        containerNavigationNestedLeftAnimateEnd: "_2KlUqnpO-sFO4Ka05slPvH",
        containerNavigationNestedLeftAnimateEnd: "_2KlUqnpO-sFO4Ka05slPvH",
        containerNavigationNestedRightAnimate: "_3aMB2WpzWrSqUT750siuEu",
        containerNavigationNestedRightAnimate: "_3aMB2WpzWrSqUT750siuEu",
        slideRight: "_3EoBuHiCPCD_K6gFwWM1aV",
        slideRight: "_3EoBuHiCPCD_K6gFwWM1aV",
        containerNavigationNestedRightAnimateEnd: "_2Woab7GuLxmrxBxEwCNQ83",
        containerNavigationNestedRightAnimateEnd: "_2Woab7GuLxmrxBxEwCNQ83",
        pageWrapper: "yJQWWPBsTHTujGQHFrHxA",
        pageWrapper: "yJQWWPBsTHTujGQHFrHxA"
    };
}, /* 70 */
/***/
function(module, exports, __webpack_require__) {
    "use strict";
    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    Object.defineProperty(exports, "__esModule", {
        value: !0
    });
    var _getPrototypeOf = __webpack_require__(11), _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf), _classCallCheck2 = __webpack_require__(12), _classCallCheck3 = _interopRequireDefault(_classCallCheck2), _createClass2 = __webpack_require__(13), _createClass3 = _interopRequireDefault(_createClass2), _possibleConstructorReturn2 = __webpack_require__(14), _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2), _inherits2 = __webpack_require__(15), _inherits3 = _interopRequireDefault(_inherits2), _react = __webpack_require__(16), _react2 = _interopRequireDefault(_react), _Drawer = __webpack_require__(71), _Drawer2 = _interopRequireDefault(_Drawer), _sharedVariables = __webpack_require__(26), CreateDrawer = function(_PureComponent) {
        function CreateDrawer() {
            return (0, _classCallCheck3.default)(this, CreateDrawer), (0, _possibleConstructorReturn3.default)(this, (CreateDrawer.__proto__ || (0, 
            _getPrototypeOf2.default)(CreateDrawer)).apply(this, arguments));
        }
        return (0, _inherits3.default)(CreateDrawer, _PureComponent), (0, _createClass3.default)(CreateDrawer, [ {
            key: "render",
            value: function() {
                var _props = this.props, children = _props.children, backIcon = _props.backIcon, header = _props.header, isOpen = _props.isOpen, isWide = _props.isWide, onBackButton = _props.onBackButton, primaryIcon = _props.primaryIcon;
                return _react2.default.createElement(_Drawer2.default, {
                    backIcon: backIcon,
                    header: header,
                    isOpen: isOpen,
                    isWide: isWide,
                    onBackButton: onBackButton,
                    primaryIcon: primaryIcon,
                    backIconOffset: _sharedVariables.createIconOffset
                }, children);
            }
        } ]), CreateDrawer;
    }(_react.PureComponent);
    CreateDrawer.propTypes = {
        backIcon: _react.PropTypes.node,
        children: _react.PropTypes.node,
        header: _react.PropTypes.node,
        isOpen: _react.PropTypes.bool,
        isWide: _react.PropTypes.bool,
        onBackButton: _react.PropTypes.func,
        primaryIcon: _react.PropTypes.node
    }, exports.default = CreateDrawer;
}, /* 71 */
/***/
function(module, exports, __webpack_require__) {
    "use strict";
    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    Object.defineProperty(exports, "__esModule", {
        value: !0
    });
    var _defineProperty2 = __webpack_require__(22), _defineProperty3 = _interopRequireDefault(_defineProperty2), _getPrototypeOf = __webpack_require__(11), _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf), _classCallCheck2 = __webpack_require__(12), _classCallCheck3 = _interopRequireDefault(_classCallCheck2), _createClass2 = __webpack_require__(13), _createClass3 = _interopRequireDefault(_createClass2), _possibleConstructorReturn2 = __webpack_require__(14), _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2), _inherits2 = __webpack_require__(15), _inherits3 = _interopRequireDefault(_inherits2), _classnames = __webpack_require__(23), _classnames2 = _interopRequireDefault(_classnames), _react = __webpack_require__(16), _react2 = _interopRequireDefault(_react), _blanket = __webpack_require__(72), _blanket2 = _interopRequireDefault(_blanket), _Drawer = __webpack_require__(73), _Drawer2 = _interopRequireDefault(_Drawer), _DrawerTrigger = __webpack_require__(37), _DrawerTrigger2 = _interopRequireDefault(_DrawerTrigger), _DrawerBackIcon = __webpack_require__(75), _DrawerBackIcon2 = _interopRequireDefault(_DrawerBackIcon), _ContainerHeader = __webpack_require__(43), _ContainerHeader2 = _interopRequireDefault(_ContainerHeader), Drawer = function(_PureComponent) {
        function Drawer() {
            return (0, _classCallCheck3.default)(this, Drawer), (0, _possibleConstructorReturn3.default)(this, (Drawer.__proto__ || (0, 
            _getPrototypeOf2.default)(Drawer)).apply(this, arguments));
        }
        return (0, _inherits3.default)(Drawer, _PureComponent), (0, _createClass3.default)(Drawer, [ {
            key: "render",
            value: function() {
                var _classNames, _props = this.props, backIcon = _props.backIcon, backIconOffset = _props.backIconOffset, header = _props.header, isOpen = _props.isOpen, isWide = _props.isWide, onBackButton = _props.onBackButton, primaryIcon = _props.primaryIcon, backIconOuterStyle = {
                    top: backIconOffset + "px"
                };
                return _react2.default.createElement("div", null, _react2.default.createElement("div", {
                    style: {
                        zIndex: 0,
                        position: "relative"
                    }
                }, _react2.default.createElement(_blanket2.default, {
                    isTinted: isOpen,
                    canClickThrough: !isOpen,
                    onBlanketClicked: onBackButton
                })), _react2.default.createElement("div", {
                    className: (0, _classnames2.default)(_Drawer2.default.drawer, (_classNames = {}, 
                    (0, _defineProperty3.default)(_classNames, _Drawer2.default.open, isOpen), (0, _defineProperty3.default)(_classNames, _Drawer2.default.wide, isWide), 
                    _classNames))
                }, _react2.default.createElement("div", {
                    className: (0, _classnames2.default)(_Drawer2.default.fixed, _Drawer2.default.side)
                }, _react2.default.createElement("div", {
                    className: (0, _classnames2.default)(_Drawer2.default.icon)
                }, primaryIcon), _react2.default.createElement("div", {
                    className: (0, _classnames2.default)(_Drawer2.default.backIconOuter),
                    style: backIconOuterStyle
                }, _react2.default.createElement("div", {
                    className: (0, _classnames2.default)(_Drawer2.default.backIcon)
                }, _react2.default.createElement(_DrawerTrigger2.default, {
                    onActivate: onBackButton
                }, _react2.default.createElement(_DrawerBackIcon2.default, {
                    isVisible: isOpen
                }, backIcon))))), _react2.default.createElement("div", {
                    className: (0, _classnames2.default)(_Drawer2.default.main)
                }, _react2.default.createElement("div", {
                    className: (0, _classnames2.default)(_Drawer2.default.fixed)
                }, _react2.default.createElement(_ContainerHeader2.default, null, header)), _react2.default.createElement("div", null, this.props.children))));
            }
        } ]), Drawer;
    }(_react.PureComponent);
    Drawer.propTypes = {
        backIcon: _react.PropTypes.node,
        backIconOffset: _react.PropTypes.number,
        children: _react.PropTypes.node,
        header: _react.PropTypes.node,
        isOpen: _react.PropTypes.bool,
        isWide: _react.PropTypes.bool,
        onBackButton: _react.PropTypes.func,
        primaryIcon: _react.PropTypes.node
    }, Drawer.defaultProps = {
        backIconOffset: 0,
        onBackButton: function() {},
        primaryIcon: null,
        isWide: !1,
        isOpen: !1
    }, exports.default = Drawer;
}, /* 72 */
/***/
function(module, exports) {
    module.exports = require("@atlaskit/blanket");
}, /* 73 */
/***/
function(module, exports, __webpack_require__) {
    // style-loader: Adds some css to the DOM by adding a <style> tag
    // load the styles
    var content = __webpack_require__(74);
    "string" == typeof content && (content = [ [ module.id, content, "" ] ]);
    // add the styles to the DOM
    __webpack_require__(20)(content, {});
    content.locals && (module.exports = content.locals);
}, /* 74 */
/***/
function(module, exports, __webpack_require__) {
    exports = module.exports = __webpack_require__(19)(), // imports
    // module
    exports.push([ module.id, "._2akT256S4t4vjk36CDxA3m{display:none}.rupOqwUt7B5KA2kZ0FOp8{background:#fff;box-shadow:-32px 0 32px 32px rgba(23,43,77,.24);color:#42526e;display:-webkit-box;display:flex;height:100%;left:0;overflow:hidden;position:fixed;-webkit-transform:translateX(-392px);transform:translateX(-392px);-webkit-transition:-webkit-transform .22s cubic-bezier(.15,1,.3,1);transition:-webkit-transform .22s cubic-bezier(.15,1,.3,1);transition:transform .22s cubic-bezier(.15,1,.3,1);transition:transform .22s cubic-bezier(.15,1,.3,1),-webkit-transform .22s cubic-bezier(.15,1,.3,1);width:360px}.rupOqwUt7B5KA2kZ0FOp8:not(._2154YQfGQ46-LYe_Mveqiu){box-shadow:none}.rupOqwUt7B5KA2kZ0FOp8._1lJaR-QUqUBxJZtBXgiCoz{width:600px;-webkit-transform:translateX(-632px);transform:translateX(-632px)}.rupOqwUt7B5KA2kZ0FOp8._1lJaR-QUqUBxJZtBXgiCoz._2154YQfGQ46-LYe_Mveqiu,.rupOqwUt7B5KA2kZ0FOp8._2154YQfGQ46-LYe_Mveqiu{-webkit-transform:translateX(0);transform:translateX(0)}._1mOteWS3gcDEYtY2rdnG_S{-webkit-box-align:center;align-items:center;box-sizing:border-box;display:-webkit-box;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;flex-direction:column;padding:16px 0;width:64px}._1mOteWS3gcDEYtY2rdnG_S ._3sK3_gbxTv64FfA49UFaV-{-webkit-box-align:center;align-items:center;display:-webkit-box;display:flex;height:40px;-webkit-box-pack:center;justify-content:center;width:40px}._1mOteWS3gcDEYtY2rdnG_S ._3aObILFLhpN6QnDrnseICh{position:absolute}.RbVgh8ZGq9uxkASInO3g6{box-sizing:border-box;height:100%;overflow-y:auto;padding:16px 8px 0;width:calc(100% - 64px)}.YDkVanDRdCF3cU2Ul0nCO{-webkit-transition:-webkit-transform .22s cubic-bezier(.15,1,.3,1);transition:-webkit-transform .22s cubic-bezier(.15,1,.3,1);transition:transform .22s cubic-bezier(.15,1,.3,1);transition:transform .22s cubic-bezier(.15,1,.3,1),-webkit-transform .22s cubic-bezier(.15,1,.3,1);-webkit-transform:translateX(392px);transform:translateX(392px)}._1lJaR-QUqUBxJZtBXgiCoz .YDkVanDRdCF3cU2Ul0nCO{-webkit-transform:translateX(632px);transform:translateX(632px)}._1lJaR-QUqUBxJZtBXgiCoz._2154YQfGQ46-LYe_Mveqiu .YDkVanDRdCF3cU2Ul0nCO,._2154YQfGQ46-LYe_Mveqiu .YDkVanDRdCF3cU2Ul0nCO{-webkit-transform:translateX(0);transform:translateX(0)}", "" ]), 
    // exports
    exports.locals = {
        hidden: "_2akT256S4t4vjk36CDxA3m",
        hidden: "_2akT256S4t4vjk36CDxA3m",
        drawer: "rupOqwUt7B5KA2kZ0FOp8",
        drawer: "rupOqwUt7B5KA2kZ0FOp8",
        open: "_2154YQfGQ46-LYe_Mveqiu",
        open: "_2154YQfGQ46-LYe_Mveqiu",
        wide: "_1lJaR-QUqUBxJZtBXgiCoz",
        wide: "_1lJaR-QUqUBxJZtBXgiCoz",
        side: "_1mOteWS3gcDEYtY2rdnG_S",
        side: "_1mOteWS3gcDEYtY2rdnG_S",
        icon: "_3sK3_gbxTv64FfA49UFaV-",
        icon: "_3sK3_gbxTv64FfA49UFaV-",
        backIconOuter: "_3aObILFLhpN6QnDrnseICh",
        backIconOuter: "_3aObILFLhpN6QnDrnseICh",
        main: "RbVgh8ZGq9uxkASInO3g6",
        main: "RbVgh8ZGq9uxkASInO3g6",
        fixed: "YDkVanDRdCF3cU2Ul0nCO",
        fixed: "YDkVanDRdCF3cU2Ul0nCO"
    };
}, /* 75 */
/***/
function(module, exports, __webpack_require__) {
    "use strict";
    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    Object.defineProperty(exports, "__esModule", {
        value: !0
    });
    var _defineProperty2 = __webpack_require__(22), _defineProperty3 = _interopRequireDefault(_defineProperty2), _getPrototypeOf = __webpack_require__(11), _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf), _classCallCheck2 = __webpack_require__(12), _classCallCheck3 = _interopRequireDefault(_classCallCheck2), _createClass2 = __webpack_require__(13), _createClass3 = _interopRequireDefault(_createClass2), _possibleConstructorReturn2 = __webpack_require__(14), _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2), _inherits2 = __webpack_require__(15), _inherits3 = _interopRequireDefault(_inherits2), _react = __webpack_require__(16), _react2 = _interopRequireDefault(_react), _classnames = __webpack_require__(23), _classnames2 = _interopRequireDefault(_classnames), _DrawerBackIcon = __webpack_require__(76), _DrawerBackIcon2 = _interopRequireDefault(_DrawerBackIcon), DrawerBackIcon = function(_PureComponent) {
        function DrawerBackIcon() {
            return (0, _classCallCheck3.default)(this, DrawerBackIcon), (0, _possibleConstructorReturn3.default)(this, (DrawerBackIcon.__proto__ || (0, 
            _getPrototypeOf2.default)(DrawerBackIcon)).apply(this, arguments));
        }
        return (0, _inherits3.default)(DrawerBackIcon, _PureComponent), (0, _createClass3.default)(DrawerBackIcon, [ {
            key: "render",
            value: function() {
                var _props = this.props, children = _props.children, isVisible = _props.isVisible;
                return _react2.default.createElement("div", {
                    className: (0, _classnames2.default)(_DrawerBackIcon2.default.backIcon, (0, _defineProperty3.default)({}, _DrawerBackIcon2.default.isVisible, isVisible))
                }, _react2.default.createElement("div", {
                    className: (0, _classnames2.default)(_DrawerBackIcon2.default.icon)
                }, children));
            }
        } ]), DrawerBackIcon;
    }(_react.PureComponent);
    DrawerBackIcon.propTypes = {
        children: _react.PropTypes.node,
        isVisible: _react.PropTypes.bool
    }, DrawerBackIcon.defaultProps = {
        isVisible: !1
    }, exports.default = DrawerBackIcon;
}, /* 76 */
/***/
function(module, exports, __webpack_require__) {
    // style-loader: Adds some css to the DOM by adding a <style> tag
    // load the styles
    var content = __webpack_require__(77);
    "string" == typeof content && (content = [ [ module.id, content, "" ] ]);
    // add the styles to the DOM
    __webpack_require__(20)(content, {});
    content.locals && (module.exports = content.locals);
}, /* 77 */
/***/
function(module, exports, __webpack_require__) {
    exports = module.exports = __webpack_require__(19)(), // imports
    // module
    exports.push([ module.id, "._2mO6JAzGFCRkedjI-8a2TA{background:#f4f5f7;border-radius:50%;color:#42526e;cursor:pointer;display:-webkit-box;display:flex;height:40px;-webkit-box-pack:center;justify-content:center;width:40px}._2mO6JAzGFCRkedjI-8a2TA:active{background:#deebff;color:#0052cc}._2mO6JAzGFCRkedjI-8a2TA ._1WKDRaJJls7GI55rLC6IAm{-webkit-box-align:center;align-items:center;display:-webkit-box;display:flex;-webkit-transform:translatex(-16px);transform:translatex(-16px);-webkit-transition:-webkit-transform .22s;transition:-webkit-transform .22s;transition:transform .22s;transition:transform .22s,-webkit-transform .22s}._2mO6JAzGFCRkedjI-8a2TA.UGnvrv3Toh__gS4cbjPxr ._1WKDRaJJls7GI55rLC6IAm{-webkit-transform:translateX(0);transform:translateX(0)}", "" ]), 
    // exports
    exports.locals = {
        backIcon: "_2mO6JAzGFCRkedjI-8a2TA",
        backIcon: "_2mO6JAzGFCRkedjI-8a2TA",
        icon: "_1WKDRaJJls7GI55rLC6IAm",
        icon: "_1WKDRaJJls7GI55rLC6IAm",
        isVisible: "UGnvrv3Toh__gS4cbjPxr",
        isVisible: "UGnvrv3Toh__gS4cbjPxr"
    };
}, /* 78 */
/***/
function(module, exports, __webpack_require__) {
    "use strict";
    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    Object.defineProperty(exports, "__esModule", {
        value: !0
    });
    var _getPrototypeOf = __webpack_require__(11), _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf), _classCallCheck2 = __webpack_require__(12), _classCallCheck3 = _interopRequireDefault(_classCallCheck2), _createClass2 = __webpack_require__(13), _createClass3 = _interopRequireDefault(_createClass2), _possibleConstructorReturn2 = __webpack_require__(14), _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2), _inherits2 = __webpack_require__(15), _inherits3 = _interopRequireDefault(_inherits2), _react = __webpack_require__(16), _react2 = _interopRequireDefault(_react), _Drawer = __webpack_require__(71), _Drawer2 = _interopRequireDefault(_Drawer), _sharedVariables = __webpack_require__(26), CustomDrawer = function(_PureComponent) {
        function CustomDrawer() {
            return (0, _classCallCheck3.default)(this, CustomDrawer), (0, _possibleConstructorReturn3.default)(this, (CustomDrawer.__proto__ || (0, 
            _getPrototypeOf2.default)(CustomDrawer)).apply(this, arguments));
        }
        return (0, _inherits3.default)(CustomDrawer, _PureComponent), (0, _createClass3.default)(CustomDrawer, [ {
            key: "render",
            value: function() {
                var _props = this.props, backIcon = _props.backIcon, children = _props.children, header = _props.header, isOpen = _props.isOpen, isWide = _props.isWide, onBackButton = _props.onBackButton, primaryIcon = _props.primaryIcon;
                return _react2.default.createElement(_Drawer2.default, {
                    backIcon: backIcon,
                    header: header,
                    isOpen: isOpen,
                    isWide: isWide,
                    onBackButton: onBackButton,
                    primaryIcon: primaryIcon,
                    backIconOffset: _sharedVariables.searchIconOffset
                }, children);
            }
        } ]), CustomDrawer;
    }(_react.PureComponent);
    CustomDrawer.propTypes = {
        backIcon: _react.PropTypes.node,
        children: _react.PropTypes.node,
        header: _react.PropTypes.node,
        isOpen: _react.PropTypes.bool,
        isWide: _react.PropTypes.bool,
        onBackButton: _react.PropTypes.func,
        primaryIcon: _react.PropTypes.node
    }, exports.default = CustomDrawer;
}, /* 79 */
/***/
function(module, exports, __webpack_require__) {
    "use strict";
    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    Object.defineProperty(exports, "__esModule", {
        value: !0
    });
    var _getPrototypeOf = __webpack_require__(11), _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf), _classCallCheck2 = __webpack_require__(12), _classCallCheck3 = _interopRequireDefault(_classCallCheck2), _createClass2 = __webpack_require__(13), _createClass3 = _interopRequireDefault(_createClass2), _possibleConstructorReturn2 = __webpack_require__(14), _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2), _inherits2 = __webpack_require__(15), _inherits3 = _interopRequireDefault(_inherits2), _react = __webpack_require__(16), _react2 = _interopRequireDefault(_react), _Drawer = __webpack_require__(71), _Drawer2 = _interopRequireDefault(_Drawer), _sharedVariables = __webpack_require__(26), CreateDrawer = function(_PureComponent) {
        function CreateDrawer() {
            return (0, _classCallCheck3.default)(this, CreateDrawer), (0, _possibleConstructorReturn3.default)(this, (CreateDrawer.__proto__ || (0, 
            _getPrototypeOf2.default)(CreateDrawer)).apply(this, arguments));
        }
        return (0, _inherits3.default)(CreateDrawer, _PureComponent), (0, _createClass3.default)(CreateDrawer, [ {
            key: "render",
            value: function() {
                var _props = this.props, children = _props.children, backIcon = _props.backIcon, header = _props.header, isOpen = _props.isOpen, isWide = _props.isWide, onBackButton = _props.onBackButton, primaryIcon = _props.primaryIcon;
                return _react2.default.createElement(_Drawer2.default, {
                    backIcon: backIcon,
                    header: header,
                    isOpen: isOpen,
                    isWide: isWide,
                    onBackButton: onBackButton,
                    primaryIcon: primaryIcon,
                    backIconOffset: _sharedVariables.searchIconOffset
                }, children);
            }
        } ]), CreateDrawer;
    }(_react.PureComponent);
    CreateDrawer.propTypes = {
        backIcon: _react.PropTypes.node,
        children: _react.PropTypes.node,
        header: _react.PropTypes.node,
        isOpen: _react.PropTypes.bool,
        isWide: _react.PropTypes.bool,
        onBackButton: _react.PropTypes.func,
        primaryIcon: _react.PropTypes.node
    }, CreateDrawer.defaultProps = {
        isWide: !0
    }, exports.default = CreateDrawer;
}, /* 80 */
/***/
function(module, exports, __webpack_require__) {
    "use strict";
    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    Object.defineProperty(exports, "__esModule", {
        value: !0
    });
    var _getPrototypeOf = __webpack_require__(11), _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf), _classCallCheck2 = __webpack_require__(12), _classCallCheck3 = _interopRequireDefault(_classCallCheck2), _createClass2 = __webpack_require__(13), _createClass3 = _interopRequireDefault(_createClass2), _possibleConstructorReturn2 = __webpack_require__(14), _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2), _inherits2 = __webpack_require__(15), _inherits3 = _interopRequireDefault(_inherits2), _react = __webpack_require__(16), _react2 = _interopRequireDefault(_react), _DrawerItem = __webpack_require__(81), _classnames = __webpack_require__(23), _classnames2 = _interopRequireDefault(_classnames), _DefaultLinkComponent = __webpack_require__(36), _DefaultLinkComponent2 = _interopRequireDefault(_DefaultLinkComponent), _NavigationItem = __webpack_require__(54), _NavigationItem2 = _interopRequireDefault(_NavigationItem), DrawerItem = function(_PureComponent) {
        function DrawerItem() {
            return (0, _classCallCheck3.default)(this, DrawerItem), (0, _possibleConstructorReturn3.default)(this, (DrawerItem.__proto__ || (0, 
            _getPrototypeOf2.default)(DrawerItem)).apply(this, arguments));
        }
        return (0, _inherits3.default)(DrawerItem, _PureComponent), (0, _createClass3.default)(DrawerItem, [ {
            key: "render",
            value: function() {
                return _react2.default.createElement("div", {
                    className: (0, _classnames2.default)(_DrawerItem.drawerItem)
                }, _react2.default.createElement(_NavigationItem2.default, {
                    action: this.props.action,
                    href: this.props.href,
                    icon: this.props.icon,
                    isCompact: this.props.isCompact,
                    linkComponent: this.props.linkComponent,
                    onClick: this.props.onClick,
                    subText: this.props.subText,
                    text: this.props.text,
                    textAfter: this.props.textAfter
                }));
            }
        } ]), DrawerItem;
    }(_react.PureComponent);
    DrawerItem.propTypes = {
        action: _react.PropTypes.node,
        href: _react.PropTypes.string,
        icon: _react.PropTypes.node,
        isCompact: _react.PropTypes.bool,
        linkComponent: _react.PropTypes.func,
        onClick: _react.PropTypes.func,
        subText: _react.PropTypes.string,
        text: _react.PropTypes.node,
        textAfter: _react.PropTypes.node
    }, DrawerItem.defaultProps = {
        isCompact: !1,
        isSelected: !1,
        linkComponent: _DefaultLinkComponent2.default
    }, exports.default = DrawerItem;
}, /* 81 */
/***/
function(module, exports, __webpack_require__) {
    // style-loader: Adds some css to the DOM by adding a <style> tag
    // load the styles
    var content = __webpack_require__(82);
    "string" == typeof content && (content = [ [ module.id, content, "" ] ]);
    // add the styles to the DOM
    __webpack_require__(20)(content, {});
    content.locals && (module.exports = content.locals);
}, /* 82 */
/***/
function(module, exports, __webpack_require__) {
    exports = module.exports = __webpack_require__(19)(), // imports
    // module
    exports.push([ module.id, ".hcdDBnVj7gmXLdsew1hWd{color:#42526e;border-radius:3px}.hcdDBnVj7gmXLdsew1hWd:hover{background:rgba(9,30,66,.04)}.hcdDBnVj7gmXLdsew1hWd:active{background:#deebff;color:#0052cc}", "" ]), 
    // exports
    exports.locals = {
        drawerItem: "hcdDBnVj7gmXLdsew1hWd",
        drawerItem: "hcdDBnVj7gmXLdsew1hWd"
    };
} ]);


//////////////////
// WEBPACK FOOTER
// /opt/atlassian/pipelines/agent/build/~/@atlaskit/navigation/dist/bundle-cjs.js
// module id = 299
// module chunks = 0